module.exports = {
  "openapi": "3.0.2",
  "info": {
    "title": "InConsult API",
    "version": "1.0"
  },
  "paths": {
    "/deleteuser": {
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about deleting a user",
      "description": "deleting a user",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a user",
        "description": "delete a user",
        "operationId": "deleteuser",
        "requestBody": {
          "description": "The new user to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deleteUser"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteUserResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getCount": {
      "servers": [
        {
          "url": "https://bjtxykde2b.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the user count",
      "description": "get the user count",
      "get": {

        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the userCount",
        "description": "Returns the count of users",
        "operationId": "getCount",
        "parameters": [
          {
            "name": "userId",
            "in": "query",
            "description": "id of the user",
            "required": true,
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all usercount",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getCount"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getundercorporatecount":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the user count",
      "description": "get the user count",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the undercorporatecount",
        "description": "Returns the count of undercorporatecount",
        "operationId": "getundercorporatecount",
        "parameters": [
          {
            "name": "userId",
            "in": "query",
            "description": "id of the user",
            "required": true,
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all undercorporatecount",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getUnderCorporateCount"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/updateuser/{token}":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the user count",
      "description": "get the user count",
      "put": {
        "tags": [
          "user"
        ],
        "summary": "Update a specific user",
        "description": "Returns the user details.",
        "operationId": "updateuser",
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "parameters": [
          {
            "name": "token",
            "in": "path",
            "description": "token should be in the header or path",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header or path"
            }
          }
        ],
        "requestBody": {
          "description": "The user details to update",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/UpdateUser"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updateUsersResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/adminuserreport":{
      "servers": [
        {
          "url": "https://bjtxykde2b.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the adminuserreport",
      "description": "get the adminuserreport",
      "get": {
        "tags": [
          "reports"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the adminuserreport",
        "description": "Returns the adminuserreport",
        "operationId": "adminuserreport",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all admin dashboard report",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getAdminUserReport"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/adminappointmentreport":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the adminappointmentreport",
      "description": "get the adminappointmentreport",
      "get": {
        "tags": [
          "reports"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the adminappointmentreport",
        "description": "Returns the adminappointmentreport",
        "operationId": "adminappointmentreport",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all AdminAppointmentReport",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getAdminAppointmentReport"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/corporatedashboard":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the corporatedashboard",
      "description": "get the corporatedashboard",
      "get": {
        "tags": [
          "reports"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the corporatedashboard",
        "description": "Returns the corporatedashboard",
        "operationId": "corporatedashboard",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all AdminAppointmentReport",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getCorporateDashboard"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/corporateuserreport":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the corporateuserreport",
      "description": "get the corporateuserreport",
      "get": {
        "tags": [
          "reports"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the corporateuserreport",
        "description": "Returns the corporateuserreport",
        "operationId": "corporateuserreport",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all AdminAppointmentReport",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getCorporateuserReport"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/corporateappointmentreport":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the corporateappointmentreport",
      "description": "get the corporateappointmentreport",
      "get": {
        "tags": [
          "reports"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the corporateappointmentreport",
        "description": "Returns the corporateappointmentreport",
        "operationId": "corporateappointmentreport",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all corporateappointmentreport",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getCorporateAppointmentReport"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/adminconsultantreport":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the adminconsultantreport",
      "description": "get the adminconsultantreport",
      "get": {
        "tags": [
          "reports"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the adminconsultantreport",
        "description": "Returns the adminconsultantreport",
        "operationId": "adminconsultantreport",
        "parameters": [
          {
            "name": "from",
            "in": "query",
            "description": "date from where",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "date from where"
            }
          },
          {
            "name": "to",
            "in": "query",
            "description": "date from to",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "date from to"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all corporateappointmentreport",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getAdminConsultantReport"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/adminappointmentreportbyrole":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the adminappointmentreportbyrole",
      "description": "get the adminappointmentreportbyrole",
      "get": {
        "tags": [
          "reports"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the adminappointmentreportbyrole",
        "description": "Returns the adminappointmentreportbyrole",
        "operationId": "adminappointmentreportbyrole",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          },
          {
            "name": "role",
            "in": "query",
            "description": "role  of the user",
            "required": true,
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "role from user"
            }
          },
          {
            "name": "from",
            "in": "query",
            "description": "date from where",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "date from where"
            }
          },
          {
            "name": "to",
            "in": "query",
            "description": "date from to",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "date from to"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all adminappointmentreportbyrole",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getAdminAppointmentReportByRole"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/verifyuser":{
      "servers": [
        {
          "url": "https://bjtxykde2b.execute-api.ap-southeast-1.amazonaws.com/develop"  
          
        }
      ],
      "summary": "verify and update user",
      "description": "get the user count",
      "post": {
        "tags": [
          "user"
        ],

        "summary": "verify a user",
        "description": "Returns the user details.",
        "operationId": "verifyuser",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should be in the header or path",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header or path"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/verifyUserResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/adminuser":{
      "servers": [
        {
          "url":"https://bjtxykde2b.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "create a admin user",
      "description": "create a admin user",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "verify a user",
        "description": "Returns the user details.",
        "operationId": "adminuser",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should be in the header or path",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header or path"
            }
          }
        ],
        "requestBody": {
          "description": "The new adminuser to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createAdmin"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createAdminResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/stripe/{domain}":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about save a logo",
      "description": "about save a logo",
      "post": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "about create save a logo",
        "description": "about save a logo",
        "operationId": "stripe/{domain}",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should in the header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the string form"
            }
          },
          {
            "name": "domain",
            "in": "path",
            "description": "name of the domain",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "name of the domain"
            }
          }
        ],
        "requestBody": {
          "description": "The new user to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/savelogo"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/saveLogoResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/listdomain":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the listdomain",
      "description": "get the listdomain",
      "get": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the listdomain",
        "description": "Returns the listdomain",
        "operationId": "listdomain",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token to Authorization",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token to Authorization"
            }
          },
          {
            "name": "subdomain",
            "in": "query",
            "description": "name of the subdomain",
            "required": true,
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "name of the subdomain"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all corporateappointmentreport",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getListDomain"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deletestripe":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the deletestripe",
      "description": "get the deletestripe",
      "delete": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Delete a specific department",
        "description": "Removes a department entry from the system.",
        "operationId": "deleteDepartment",
        "parameters": [
          {
            "name": "Authorization || userId",
            "in": "header",
            "description": "token should either in header or query",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should either in header or query"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteStripeResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/liststripe/{userId}":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the listsripe",
      "description": "get the listsripe",
      "get": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the liststripe",
        "description": "Returns the count of liststripe",
        "operationId": "getliststripe",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token should be in path or header",
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          },
          {
            "name": "userId",
            "in": "path",
            "description": "token should be in path or header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all undercorporatecount",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getlistStripe"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/stripecreate":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a stripe",
      "description": "creaate a stripe",
      "post": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a stripe",
        "description": "Returns creaate a stripes.",
        "operationId": "stripecreate",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token should be in the header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header"
            }
          }
        ],
        "requestBody": {
          "description": "create a stripe",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createStripe"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createStripeResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/deletelogo":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "delete a logo",
      "description": "delete a logo",
      "delete": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Delete a logo",
        "description": "Delete a logo",
        "operationId": "deletelogs",
        "requestBody": {
          "description": "delete a stripe",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deleteLogo"
              }
            }
          }
        },
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token should be in the header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteLogoResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/freelicense":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a freeLicense",
      "description": "creaate a freeLicense",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a createfreelicense",
        "description": "Returns creaate a createfreelicense.",
        "operationId": "createfreelicense",
        "requestBody": {
          "description": "create a stripe",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createFreeLicense"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createFreeLicenseResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/signIn":{
      "servers": [
        {
          "url": "https://bjtxykde2b.execute-api.ap-southeast-1.amazonaws.com/develop" 
        }
      ],
      "summary": "creaate a sign",
      "description": "creaate a sign",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a sign",
        "description": "Returns creaate a sign.",
        "operationId": "sign",
        "requestBody": {
          "description": "create a sign",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createSignin"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createSigninResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/getOtp":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a send otp",
      "description": "creaate a send otp",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a sendotp",
        "description": "Returns creaate a sendotp.",
        "operationId": "sign",
        "requestBody": {
          "description": "create a sendotp",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createSendOtp"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createSendOtpResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/verificationOtp":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a verifyOTP",
      "description": "creaate a verifyOTP",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a verifyOtp",
        "description": "Returns creaate a verifyOtp.",
        "operationId": "verifyOTP",
        "requestBody": {
          "description": "create a verifyOTP",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/verifyOTP"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/verifyOTPResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/changePassword":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a changePassword",
      "description": "creaate a changePassword",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a changePassword",
        "description": "Returns creaate a changePassword.",
        "operationId": "changePassword",
        "requestBody": {
          "description": "create a changePassword",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/changePassword"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/changePasswordResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/getUser/{token}":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "get the user ",
      "description": "get the user ",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the user",
        "description": "Returns the user",
        "operationId": "getUser",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token of the user either in header or path",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user either in header or path"
            }
          },
          {
            "name": "token",
            "in": "path",
            "description": "token of the user either in header or path",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user either in header or path"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all user",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getUserDetailResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/refreshToken":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a stripe",
      "description": "creaate a stripe",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a stripe",
        "description": "Returns creaate a stripes.",
        "operationId": "stripecreate",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token should be in the header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header"
            }
          }
        ],
        "requestBody": {
          "description": "create a stripe",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createRefreshToken"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createStripeResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/consultantList":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the consultantlist",
      "description": "get the consultantlist",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the consultantlist",
        "description": "Returns the consultantlist",
        "operationId": "consultantlist",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          },
          {
            "name": "skip",
            "in": "query",
            "description": "no of pages to skip",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "no of pages to skip"
            }
          },
          {
            "name": "limit",
            "in": "query",
            "description": "no of pages limit",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "no of pages limit"
            }
          },
          {
            "name": "searchKey",
            "in": "query",
            "description": "value to search",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "value to search"
            }
          },
          {
            "name": "consultRole",
            "in": "query",
            "description": "Role to consult",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "Role of the consult"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all consultantlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getCousultantListResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/consultantTypeList":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the consultantTypeList",
      "description": "get the consultantTypeList",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the consultantTypeList",
        "description": "Returns the consultantTypeList",
        "operationId": "consultantTypeList",
        "parameters": [
          {
            "name": "skip",
            "in": "query",
            "description": "no of pages to skip",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "no of pages to skip"
            }
          },
          {
            "name": "limit",
            "in": "query",
            "description": "no of pages limit",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "number",
              "description": "no of pages limit"
            }
          },
          {
            "name": "searchKey",
            "in": "query",
            "description": "value to search",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "value to search"
            }
          },
          {
            "name": "consultantType",
            "in": "query",
            "description": "Type to consultant",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "Type to consultant"
            }
          },
          {
            "name": "corporateId",
            "in": "query",
            "description": "id of the corporate",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the corporate"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all consultantlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getCousultantTypeListResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getUserByPhoneAndSubdomain":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getUserByPhoneAndSubdomain",
      "description": "get the getUserByPhoneAndSubdomain",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the getUserByPhoneAndSubdomain",
        "description": "Returns the getUserByPhoneAndSubdomain",
        "operationId": "getUserByPhoneAndSubdomain",
        "parameters": [
          {
            "name": "username",
            "in": "query",
            "description": "username of the user",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "username of the user"
            }
          },
          {
            "name": "subdomain",
            "in": "query",
            "description": "subdomain",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "subdomain"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all getUserByPhoneAndSubdomain",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getUserByPhoneAndSubdomainResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/userdetails":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the userdetails",
      "description": "get the userdetails",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the userdetails",
        "description": "Returns the userdetails",
        "operationId": "userdetails",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token can be passed either passed in header or query",
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token can be passed either passed in header or query"
            }
          },
          {
            "name": "userId",
            "in": "query",
            "description": "token can be passed either passed in header or query",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
            "description": "token can be passed either passed in header or query"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all userdetails",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getUserResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/updateconsultuser":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "update the consultfantuser",
      "description": "update the consultfantuser",
      "put": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Update a specific consult user",
        "description": "Update a specific consult user.",
        "operationId": "updateuser",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should be in the header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header"
            }
          },
          {
            "name": "userId",
            "in": "query",
            "description": "id of the user",
            "required": true,
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
            }
          }
        ],
        "requestBody": {
          "description": "The user details to update",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/updateconsultuser"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/UpdateConsultantUserResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/getunlicensed":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getunlicensed",
      "description": "get the getunlicensed",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the getunlicensed",
        "description": "Returns the getunlicensed",
        "operationId": "getunlicensed",
        "responses": {
          "200": {
            "description": "Succesfully returned all getunlicensed",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getunlicensedResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/doctoruploadlist":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the doctoruploadlist",
      "description": "get the doctoruploadlist",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "parameters": [],
        "summary": "Get all the doctoruploadlist",
        "description": "Returns the doctoruploadlist",
        "operationId": "doctoruploadlist",
        "responses": {
          "200": {
            "description": "Succesfully returned all doctoruploadlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/doctoruploadlistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deletewaitingroomupload":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "delete the deletewaitingroomupload",
      "description": "delete the deletewaitingroomupload",
      "delete": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete the deletewaitingroomupload",
        "description": "delete the deletewaitingroomupload",
        "operationId": "deletewaitingroomupload",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token should either in header or query",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should either in header or query"
            }
          }
        ],
        "requestBody": {
          "description": "delete the deletewaitingroomupload",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deletewaitingroomupload"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deletewaitingroomuploadResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/profilepic":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a profilepic",
      "description": "creaate a profilepic",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a profilepic",
        "description": "Returns creaate a profilepic.",
        "operationId": "profilepic",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token should either in header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should either in header"
            }
          }
        ],
        "requestBody": {
          "description": "create a profilepic",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/profilepic"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/profilepicResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/currentuserinfo":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the currentuserinfo",
      "description": "get the currentuserinfo",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the currentuserinfo",
        "description": "Returns the currentuserinfo",
        "operationId": "currentuserinfo",
        "parameters": [
          {
            "name": "Authorization",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
            }
          },
          {
            "name": "userId",
            "in": "query",
            "description": "userId of user",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "userId of user"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all currentuserinfo",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/currentuserinfoResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/listallcorporates":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the listallcorporates",
      "description": "get the listallcorporates",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the listallcorporates",
        "description": "Returns the listallcorporates",
        "operationId": "listallcorporates",
        "parameters": [
          {
            "name": "adminId",
            "in": "query",
            "description": "adminId of admin",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "adminId of admin"
            }
          },
          {
            "name": "consultRole",
            "in": "query",
            "description": "role of consult",
            "style": "form",
            "required": true,
            "explode": true,
            "schema": {
              "type": "string",
              "description": "role of consult"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all listallcorporates",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/listallcorporatesResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deletefile":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "delete the deletefile",
      "description": "delete the deletefile",
      "delete": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete the deletefile",
        "description": "delete the deletefile",
        "operationId": "deletefile",
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deletefileResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/userlistbysub":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the userlistbysub",
      "description": "get the userlistbysub",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the userlistbysub",
        "description": "Returns the userlistbysub",
        "operationId": "userlistbysub",
        "parameters": [
          {
            "name": "searchKey",
            "in": "query",
            "description": "searchKey value",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "searchKey value"
            }
          },
          {
            "name": "skip",
            "in": "query",
            "description": "no  of pages to skip",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "no  of pages to skip"
            }
          },
          {
            "name": "limit",
            "in": "query",
            "description": "no  of pages limit",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "no  of pages limit"
            }
          },
          {
            "name": "userId",
            "in": "query",
            "description": "id of the corporate",
            "style": "form",
            "required": true,
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the corporate"
            }
          },
          {
            "name": "consultRole",
            "in": "query",
            "description": "consultRole",
            "style": "form",
            "required": true,
            "explode": true,
            "schema": {
              "type": "string",
              "description": "consultRole"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all userlistbysub",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/userlistbysubResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/createuser":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a user",
      "description": "creaate a user",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a user",
        "description": "Returns creaate a user.",
        "operationId": "user",
        "requestBody": {
          "description": "create a profilepic",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createConfirmUser"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createConfirmUserResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/domainconfirmation":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "creaate a domainconfirmation",
      "description": "creaate a domainconfirmation",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a domainconfirmation",
        "description": "Returns creaate a domainconfirmation.",
        "operationId": "domainconfirmation",
        "requestBody": {
          "description": "create a domainconfirmation",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createDomainconfirmation"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createDomainconfirmationResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/domainlist/{domain}":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the domainlist",
      "description": "get the domainlist",
      "get": {
        "tags": [
          "domain"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the domainlist",
        "description": "Returns the domainlist",
        "operationId": "domainlist",
        "parameters": [
          {
            "name": "domain",
            "in": "path",
            "description": "domain of user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "domain of user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all domainlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/domainlistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deleteprofile":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"  
        }
      ],
      "summary": "delete a deleteprofile",
      "description": "delete a deleteprofile",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a deleteprofile",
        "description": "Returns delete a deleteprofile.",
        "operationId": "deleteProfile",
        "requestBody": {
          "description": "delete a deleteprofile",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deleteProfilePic"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteProfilePicResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/countryList":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the countryList",
      "description": "get the countryList",
      "get": {
        "tags": [
          "config"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the countryList",
        "description": "Returns the countryList",
        "operationId": "countryList",
        "responses": {
          "200": {
            "description": "Succesfully returned all userlistbysub",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/countryListResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/stateList":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the stateList",
      "description": "get the stateList",
      "get": {
        "tags": [
          "config"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the stateList",
        "description": "Returns the stateList",
        "operationId": "stateList",
        "responses": {
          "200": {
            "description": "Succesfully returned all stateList",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/stateListResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/diagonisislist":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the diagonisislist",
      "description": "get the diagonisislist",
      "get": {
        "tags": [
          "config"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the diagonisislist",
        "description": "Returns the diagonisislist",
        "operationId": "diagonisislist",
        "responses": {
          "200": {
            "description": "Succesfully returned all diagonisislist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/diagonisislistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/diseaseslist":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the diseaseslist",
      "description": "get the diseaseslist",
      "get": {
        "tags": [
          "config"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the diseaseslist",
        "description": "Returns the diseaseslist",
        "operationId": "diseaseslist",
        "responses": {
          "200": {
            "description": "Succesfully returned all diseaseslist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/diseaseslistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/qualificationlist":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the qualificationlist",
      "description": "get the qualificationlist",
      "get": {
        "tags": [
          "config"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the qualificationlist",
        "description": "Returns the qualificationlist",
        "operationId": "qualificationlist",
        "responses": {
          "200": {
            "description": "Succesfully returned all qualificationlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/qualificationlistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/specializationlist":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the specializationlist",
      "description": "get the specializationlist",
      "get": {
        "tags": [
          "config"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the specializationlist",
        "description": "Returns the specializationlist",
        "operationId": "specializationlist",
        "responses": {
          "200": {
            "description": "Succesfully returned all specializationlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/specializationlistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/departmentlist":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the departmentlist",
      "description": "get the departmentlist",
      "get": {
        "tags": [
          "config"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the departmentlist",
        "description": "Returns the departmentlist",
        "operationId": "departmentlist",
        "responses": {
          "200": {
            "description": "Succesfully returned all departmentlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/departmentlistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/frequsers/{id}":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the frequsers",
      "description": "get the frequsers",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the frequsers",
        "description": "Returns the frequsers",
        "operationId": "frequsers",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "description": "id of user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all frequsers",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/frequsersResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/freqconsultants/{id}":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the freqconsultants",
      "description": "get the freqconsultants",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the freqconsultants",
        "description": "Returns the freqconsultants",
        "operationId": "freqconsultants",
        "parameters": [
          {
            "name": "id",
            "in": "path",
            "description": "id of user in appointment",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of user in appiointment"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all freqconsultants",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/freqconsultantsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/consultantdata":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the consultantdata",
      "description": "get the consultantdata",
      "get": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the consultantdata",
        "description": "Returns the departmentlist",
        "operationId": "consultantdata",
        "parameters": [
          {
            "name": "request",
            "in": "query",
            "description": "request of user (consultantcat || consultantspec || designation)",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "request of user (consultantcat || consultantspec || designation)"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all consultantdata",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/consultantdataResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/consultantcount":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the consultantcount",
      "description": "get the consultantcount",
      "get": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the consultantcount",
        "description": "Returns the consultantcount",
        "operationId": "consultantcount",
        "parameters": [
          {
            "name": "corporateId",
            "in": "query",
            "description": "corporateId of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "corporateId of user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all consultantcount",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/consultantcountResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/subdomains":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the subdomains",
      "description": "get the subdomains",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the subdomains",
        "description": "Returns the subdomains",
        "operationId": "subdomains",
        "parameters": [
          {
            "name": "searchKey",
            "in": "query",
            "description": "searchKey of value",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "searchKey of value"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all subdomains",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/subdomainsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/support":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the subdomains",
      "description": "get the subdomains",
      "get": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the support",
        "description": "Returns the support",
        "operationId": "support",
        "parameters": [
          {
            "name": "userId",
            "in": "query",
            "description": "userId of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "userId of user"
              }
          },
          {
            "name": "subdomain",
            "in": "query",
            "description": "subdomain of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "subdomain of user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all subdomains",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/subdomainsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "post": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a support",
        "description": "create a support",
        "operationId": "support1",
        "requestBody": {
          "description": "support",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createCustomerCare"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createCustomerCareResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/mailtocare":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the mailtocare",
      "description": "get the mailtocare",
      "post": {
        "tags": [
          "settings"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a mailtocare",
        "description": "create a mailtocare",
        "operationId": "mailtocare",
        "requestBody": {
          "description": "mailtocare",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createmailtocare"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createmailtocareResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/licenseurldetails":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the licenseurldetails",
      "description": "get the licenseurldetails",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the licenseurldetails",
        "description": "Returns the licenseurldetails",
        "operationId": "licenseurldetails",
        "responses": {
          "200": {
            "description": "Succesfully returned all licenseurldetails",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/licenseurldetailsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/licensedetails":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "creaate the licensedetails",
      "description": "creaate the licensedetails",
      "post": {
        "tags": [
          "LicenseManagement"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a licensedetails",
        "description": "create a licensedetails",
        "operationId": "licensedetails",
        "requestBody": {
          "description": "licensedetails",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createlicensedetails"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createlicensedetailsResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/updatepayment":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "creaate the updatepayment",
      "description": "creaate the updatepayment",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a updatepayment",
        "description": "create a updatepayment",
        "operationId": "updatepayment",
        "requestBody": {
          "description": "updatepayment",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createupdatepayment"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createupdatepaymentResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/usercorps":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the usercorps",
      "description": "get the usercorps",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the usercorps",
        "description": "Returns the usercorps",
        "operationId": "usercorps",
        "parameters": [
          {
            "name": "username",
            "in": "query",
            "required": true,
            "description": "username of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "username of user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all consultantcount",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/usercorpsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getpaidandunpaidsubdomains":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getpaidandunpaidsubdomains",
      "description": "get the getpaidandunpaidsubdomains",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the getpaidandunpaidsubdomains",
        "description": "Returns the getpaidandunpaidsubdomains",
        "operationId": "getpaidandunpaidsubdomains",
        "parameters": [
          {
            "name": "username",
            "in": "query",
            "required": true,
            "description": "username of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "username of user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all getpaidandunpaidsubdomains",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getpaidandunpaidsubdomainsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getcorporatepayment":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getcorporatepayment",
      "description": "get the getcorporatepayment",
      "get": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the getcorporatepayment",
        "description": "Returns the getcorporatepayment",
        "operationId": "getcorporatepayment",
        "parameters": [
          {
            "name": "username",
            "in": "query",
            "required": true,
            "description": "username of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "username of user"
              }
          },
          {
            "name": "subdomain",
            "in": "query",
            "required": true,
            "description": "subdomain of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "subdomain of user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all getcorporatepaymentResponse",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getcorporatepaymentResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/createlicense":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "creaate the createlicense",
      "description": "creaate the createlicense",
      "post": {
        "tags": [
          "LicenseManagement"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a createlicense",
        "description": "create a createlicense",
        "operationId": "createlicense",
        "requestBody": {
          "description": "createlicense",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createlicense"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createlicenseResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/createorder":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "creaate the createorder",
      "description": "creaate the createorder",
      "post": {
        "tags": [
          "payments"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a createorder",
        "description": "create a createorder",
        "operationId": "createorder",
        "requestBody": {
          "description": "createorder",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createorder"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createorderResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/capturepayment":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "creaate the capturepayment",
      "description": "creaate the capturepayment",
      "post": {
        "tags": [
          "payments"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a capturepayment",
        "description": "create a capturepayment",
        "operationId": "capturepayment",
        "requestBody": {
          "description": "capturepayment",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/capturepayment"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/capturepaymentResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/applycoupon/{code}":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the applycoupon",
      "description": "get the applycoupon",
      "get": {
        "tags": [
          "payments"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the applycoupon",
        "description": "Returns the applycoupon",
        "operationId": "applycoupon",
        "parameters": [
          {
            "name": "token",
            "in": "query",
            "description": "generated token",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "couponCode",
            "in": "path",
            "description": "couponCode of the payment",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "couponCode of the payment"
              }
          },
          {
            "name": "product",
            "in": "query",
            "description": "product of the payment",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "product of the payment"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all payment",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/paymentResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/createcoupon":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "creaate the createcoupon",
      "description": "creaate the createcoupon",
      "post": {
        "tags": [
          "payments"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a createcoupon",
        "description": "create a createcoupon",
        "operationId": "createcoupon",
        "requestBody": {
          "description": "createcoupon",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createcoupon"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createcouponResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/doctor-slots":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the doctor-slots",
      "description": "get the doctor-slots",
      "get": {
        "tags": [
          "slots"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the doctor-slots",
        "description": "Returns the doctor-slots",
        "operationId": "doctor-slots",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all doctor-slots",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/doctorslotsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/doctor-schedules":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the doctor-schedules",
      "description": "get the doctor-schedules",
      "get": {
        "tags": [
          "slots"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the doctor-schedules",
        "description": "Returns the doctor-schedules",
        "operationId": "doctor-schedules",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all doctor-slots",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/doctorschedulesResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/appointment":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "creaate the appointment",
      "description": "creaate the appointment",
      "post": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a appointment",
        "description": "create a appointment",
        "operationId": "appointment",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "appointment",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createappointment"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createappointmentResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "put": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Update a specific appointment",
        "description": "Returns the user appointment.",
        "operationId": "appointmentupdate",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should be in the header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header"
            }
          }
        ],
        "requestBody": {
          "description": "The user details to update",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/updateAppointment"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updateAppointmentResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/appointment/{user}":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the appointment",
      "description": "get the appointment",
      "get": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the appointment",
        "description": "Returns the appointment",
        "operationId": "appointments",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "user",
            "in": "path",
            "description": "user of the appointment",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "user of the appointment"
              }
          },
          {
            "name": "from",
            "in": "query",
            "description": "from date",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "from date"
              }
          },
          {
            "name": "to",
            "in": "query",
            "description": "to date",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "to date"
              }
          },
          {
            "name": "type",
            "in": "query",
            "description": "type of the appointment",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "type of the appointment"
              }
          },
          {
            "name": "status",
            "in": "query",
            "description": "status of the appointment",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "status of the appointment"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all appointment",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getappointmentResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/consultant-appointment/{id}":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the consultant-appointment",
      "description": "get the consultant-appointment",
      "get": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the consultant-appointment",
        "description": "Returns the consultant-appointment",
        "operationId": "consultant-appointment",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "id",
            "in": "path",
            "description": "id of the consultantpayment",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the consultantpayment"
              }
          },
          {
            "name": "from",
            "in": "query",
            "description": "from date",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "from date"
              }
          },
          {
            "name": "to",
            "in": "query",
            "description": "to date",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "to date"
              }
          }
          
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all payment",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/consultantappointmentResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getappointment":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getappointment",
      "description": "get the getappointment",
      "get": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the consultant-appointment",
        "description": "Returns the consultant-appointment",
        "operationId": "consultant-appointment",
        "parameters": [
          {
            "name": "appointmentId",
            "in": "query",
            "description": "id of the appointmentId",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the appointmentId"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all appointmentId",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getappointmentIdResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getConsultation":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getConsultation",
      "description": "get the getConsultation",
      "get": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the getConsultation",
        "description": "Returns the getConsultation",
        "operationId": "getConsultation",
        "parameters": [
          {
            "name": "appointmentId",
            "in": "query",
            "description": "id of the appointmentId",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the appointmentId"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all appointmentId",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getConsultantResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getInvoiceData":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getInvoiceData",
      "description": "get the getInvoiceData",
      "get": {
        "tags": [
          "invoice"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the getInvoiceData",
        "description": "Returns the getInvoiceData",
        "operationId": "getInvoiceData",
        "responses": {
          "200": {
            "description": "Succesfully returned all getInvoiceData",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getInvoiceDataResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/chat": {
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating and getting a chat",
      "description": " creating a chat",
      "post": {
        "tags": [
          "chat"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a chat",
        "description": "create a chat",
        "operationId": "create a chat",
        "requestBody": {
          "description": "The new user to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createChat"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createChatResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "get": {
        "tags": [
          "chat"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the chat",
        "description": "Returns the chat",
        "operationId": "chats",
        "parameters": [
          {
            "name": "appointmentId",
            "in": "query",
            "description": "id of the appointmentId",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the appointmentId"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all chat",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getChatResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/patientmedical": {
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating and getting and update patientmedical",
      "description": " creating a patientmedical",
      "post": {
        "tags": [
          "patientmedical"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a patientmedical",
        "description": "create a patientmedical",
        "operationId": "create a patientmedical",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "The new patientmedical to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createPatientmedical"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createPatientmedicalResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "get": {
        "tags": [
          "patientmedical"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the patientmedical",
        "description": "Returns the patientmedical",
        "operationId": "patientmedicals",
        "parameters": [

          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          },
          {
            "name": "userId",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all patientmedical",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/patientMedicalResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "delete": {
        "tags": [
          "patientmedical"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a patientmedical",
        "description": "delete a patientmedical",
        "operationId": "patientmedicalss",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should in the sub",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the string form"
            }
          }
        ],
        "requestBody": {
          "description": "The new user to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deletePatientMedical"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deletePatientMedicalResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/drugalergies": {
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating and getting and update drugalergies",
      "description": " creating a drugalergies",
      "post": {
        "tags": [
          "drugalergies"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a drugalergies",
        "description": "create a drugalergies",
        "operationId": "create a drugalergies",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "The new patientmedical to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createdrugalergies"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createdrugalergiesResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "get": {
        "tags": [
          "drugalergies"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the drugalergies",
        "description": "Returns the drugalergies",
        "operationId": "drugalergies",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          },
          {
            "name": "userId",
            "in": "query",
            "description": "userId of the user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "userId of the user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all drugalergies",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/drugalergiesResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "delete": {
        "tags": [
          "drugalergies"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a drugalergies",
        "description": "delete a drugalergies",
        "operationId": "drugalergiesssss",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should in the sub",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the string form"
            }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of the drugalergies",
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the drugalergies"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteDrugAllergiesResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "put": {
        "tags": [
          "drugalergies"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Update a specific drugalergies",
        "description": "Returns the user drugalergies.",
        "operationId": "drugalergiesssssss",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token should be in the header",
            "required": true,
            "style": "simple",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "token should be in the header"
            }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of the drugalergies",
            "required": true,
            "style": "form",
            "explode": true,
            "schema": {
              "type": "string",
              "description": "id of the drugalergies"
            }
          }
        ],
        "requestBody": {
          "description": "The user details to update",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/updatedrugalergies"
              }
            }
          },
          "required": true
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updatedrugalergiesResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal server error"
          }
        }
      }
    },
    "/past/appointments/{id}":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating userpastappoints",
      "description": " creating a userpastappoints",
      "post": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a userpastappoints",
        "description": "create a userpastappoints",
        "operationId": "create a userpastappoints",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "id",
            "in": "path",
            "description": "id of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the usern"
              }
          }
        ],
        "requestBody": {
          "description": "The new pastlistAppoint to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createpastList"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createpastListResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/invite":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating sendinvitation",
      "description": " creating a sendinvitation",
      "post": {
        "tags": [
          "sendinvitation"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a sendinvitation",
        "description": "create a sendinvitation",
        "operationId": "create a sendinvitation",
        "requestBody": {
          "description": "The new pastlistAppoint to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createInvitation"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createInvitationResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/sendsmslambda":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the sendsmslambda",
      "description": "get the sendsmslambda",
      "get": {
        "tags": [
          "sendsmslambda"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the sendsmslambda",
        "description": "Returns the sendsmslambda",
        "operationId": "sendsmslambda",
        "responses": {
          "200": {
            "description": "Succesfully returned all sendsmslambda",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getsendsmslambdaResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/cancel-appointment": {
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about and update cancel-appointment",
      "description": " update a cancel-appointment",
      "put": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a cancel-appointment",
        "description": "create a cancel-appointment",
        "operationId": "create a cancel-appointment",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "The new patientmedical to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/updatecancelappointment"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updatecancelappointmentResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/getdoctorsigns":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the getdoctorsigns",
      "description": "get the getdoctorsigns",
      "get": {
        "tags": [
          "doctorsign"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the getdoctorsigns",
        "description": "Returns the getdoctorsigns",
        "operationId": "getdoctorsigns",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "userId",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all getdoctorsigns",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getdoctorsignsResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deletepatientmedicalfile":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about deleting a deletepatientmedicalfile",
      "description": " delete a deletepatientmedicalfile",
      "delete": {
        "tags": [
          "patientmedical"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a deletepatientmedicalfile",
        "description": "delete a deletepatientmedicalfile",
        "operationId": "deletepatientmedicalfile",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteFiledeleteResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deletedrugalergy":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about deleting a deletedrugalergy",
      "description": " delete a deletedrugalergy",
      "post": {
        "tags": [
          "drugalergies"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a deletedrugalergy",
        "description": "delete a deletedrugalergy",
        "operationId": "deletedrugalergy",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteDrugAllergyResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/enterparticipantlogs":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating a enterparticipantlogs",
      "description": "  creating a enterparticipantlogs",
      "post": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "schedule",
        "description": "creating a enterparticipantlogs",
        "operationId": "creating a enterparticipantlogs",
        "requestBody": {
          "description": "The new enterparticipantlogs to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createenterparticipantlogs"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createenterparticipantlogsResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/exitparticipantlogs":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating a exitparticipantlogs",
      "description": "  creating a exitparticipantlogs",
      "post": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "schedule",
        "description": "creating a exitparticipantlogs",
        "operationId": "creating a exitparticipantlogs",
        "requestBody": {
          "description": "The new exitparticipantlogs to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createexitparticipantlogs"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createexitparticipantlogsResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/updatesuccesscall":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating a updatesuccesscall",
      "description": "  creating a updatesuccesscall",
      "post": {
        "tags": [
          "appiointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "schedule",
        "description": "creating a updatesuccesscall",
        "operationId": "creating a updatesuccesscall",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "The new updatesuccesscall to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createupdatesuccesscall"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createupdatesuccesscallResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/inviteuser":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating a inviteuser",
      "description": "  creating a inviteuser",
      "post": {
        "tags": [
          "invitation"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "schedule",
        "description": "creating a inviteuser",
        "operationId": "creating a inviteuser",
        "requestBody": {
          "description": "The new inviteuser to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createinviteuser"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createinviteuserResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/chatlist":{
      "servers": [
        {
          "url": " https://jjvef66d2c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "get the chatlist",
      "description": "get the chatlist",
      "get": {
        "tags": [
          "chat"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the chatlist",
        "description": "Returns the chatlist",
        "operationId": "chatlist",
        "parameters": [
          {
            "name": "appointmentId",
            "in": "query",
            "description": "id of the appiointment",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the appiointment"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all chatlist",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getchatlistResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/paymentupdatewebhook":{
      "servers": [
        {
          "url": " https://v6po3v5l1c.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating a paymentupdatewebhook",
      "description": "  creating a paymentupdatewebhook",
      "post": {
        "tags": [
          "payment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "schedule",
        "description": "creating a paymentupdatewebhook",
        "operationId": "creating a paymentupdatewebhook",
        "requestBody": {
          "description": "The new paymentupdatewebhook to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createpaymentupdatewebhook"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createpaymentupdatewebhookResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/schedule":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about creating a schedule",
      "description": "  creating a schedule",
      "put": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "update schedule",
        "description": "update a schedule",
        "operationId": "update a schedule",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          }
        ],
        "requestBody": {
          "description": "The new schedule to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/updateschedule"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updatescheduleResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "get": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the schedule",
        "description": "Returns the schedule",
        "operationId": "scheduless",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all chat",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getScheduleResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "post": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a schedule",
        "description": "creating a schedule",
        "operationId": "creating a schedule",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "The new updatesuccesscall to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createschedule"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createscheduleResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "delete": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a schedule",
        "description": "delete a schedule",
        "operationId": "delete a schedule",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "id of user"
              }
          },
          {
            "name": "from",
            "in": "query",
            "description": "from date",
            "style": "form",
            "schema": {
              "type": "number",
              "description": "from date"
              }
          },
          {
            "name": "to",
            "in": "query",
            "description": "to date",
            "style": "form",
            "schema": {
              "type": "number",
              "description": "to date"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deletescheduleResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deleteschedule":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about delete a schedule",
      "description": "  delete a schedule",
      "delete": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a schedule",
        "description": "delete a schedule",
        "operationId": "delete a schedule",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "from",
            "in": "query",
            "description": "from date",
            "style": "form",
            "schema": {
              "type": "number",
              "description": "from date"
              }
          },
          {
            "name": "to",
            "in": "query",
            "description": "to date",
            "style": "form",
            "schema": {
              "type": "number",
              "description": "to date"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteschResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/confirmdeletesch":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about get a schedule",
      "description": "  get a schedule",
      "get": {
        "tags": [
          "schedule"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the schedule",
        "description": "Returns the schedule",
        "operationId": "scheduless",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          },
          {
            "name": "from",
            "in": "query",
            "description": "from date",
            "style": "form",
            "schema": {
              "type": "number",
              "description": "from date"
              }
          },
          {
            "name": "to",
            "in": "query",
            "description": "to date",
            "style": "form",
            "schema": {
              "type": "number",
              "description": "to date"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id ",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the schedule"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all chat",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getconfirmdeleteschResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/slots":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about crud a slots",
      "description": "  creating a slots",
      "put": {
        "tags": [
          "slots"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "update slots",
        "description": "update a slots",
        "operationId": "update a slots",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of slot",
            "style": "form",
            "required": true,
            "schema": {
              "type": "number",
              "description": "id of slot"
              }
          }
        ],
        "requestBody": {
          "description": "The new schedule to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/updateslots"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updateslotsResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "get": {
        "tags": [
          "slots"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the slots",
        "description": "Returns the slots",
        "operationId": "slotsss",
        "parameters": [
          {
            "name": "id",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all chat",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getSlotResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "post": {
        "tags": [
          "slot"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a slot",
        "description": "creating a slot",
        "operationId": "creating a slot",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "The new slot to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createslot"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createslotResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "delete": {
        "tags": [
          "slot"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a slot",
        "description": "delete a slot",
        "operationId": "delete a slot",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          },
          {
            "name": "id",
            "in": "query",
            "description": "id of user",
            "style": "form",
            "schema": {
              "type": "string",
              "description": "id of user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteslotResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/disabledates":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about crud a disabledates",
      "description": "  creating a disabledates",
      "post": {
        "tags": [
          "disabledates"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a disabledates",
        "description": "creating a disabledates",
        "operationId": "creating a disabledates",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "generated token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "generated token"
              }
          }
        ],
        "requestBody": {
          "description": "The new disabledates to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createdisabledates"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createdisabledatesResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "get": {
        "tags": [
          "disabledates"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the disabledates",
        "description": "Returns the disabledates",
        "operationId": "disabledatessss",
        "parameters": [
          {
            "name": "id",
            "in": "query",
            "description": "id of the user",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the user"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all disabledates",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getdisabledatesResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/appointment-status":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about update a appointment-status",
      "description": "update a appointment-status",
      "put": {
        "tags": [
          "appointment"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "update a appointment-status",
        "description": "update a appointment-status",
        "operationId": "update a appointment-status",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          }
        ],
        "requestBody": {
          "description": "The new schedule to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/appointmentstatus"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/appointmentstatusResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/waitingroomupload":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about update a appointment-status",
      "description": "update a appointment-status",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a waitingroomupload",
        "description": "create a waitingroomupload",
        "operationId": "create a waitingroomupload",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          }
        ],
        "requestBody": {
          "description": "The new schedule to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/waitingroomupload"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/waitingroomuploadResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deleteupload":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about update a deleteupload",
      "description": "update a deleteupload",
      "post": {
        "tags": [
          "user"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "create a deleteupload",
        "description": "create a deleteupload",
        "operationId": "create a deleteupload",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          },
          {
            "name": "uploadkey",
            "in": "header",
            "description": "uploadkey",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "uploadkey"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/uploadKeyResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/prescription":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about crud a prescription",
      "description": "  creating a prescription",
      "get": {
        "tags": [
          "prescription"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the prescription",
        "description": "Returns the prescription",
        "operationId": "prescription",
        "parameters": [
          {
            "name": "appointmentId",
            "in": "query",
            "description": "id of the appointmentId",
            "style": "form",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of the appointmentId"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all chat",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getPrescriptionResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "post": {
        "tags": [
          "prescription"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a prescription",
        "description": "creating a prescription",
        "operationId": "creating a prescription",
        "requestBody": {
          "description": "The new prescription to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createprescription"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createprescriptionResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "delete": {
        "tags": [
          "prescription"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a prescription",
        "description": "delete a prescription",
        "operationId": "delete a prescription",
        "requestBody": {
          "description": "The new prescription to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deleteprescription"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteprescriptionResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/prescription/{appointmentId}":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about crud a prescription",
      "description": "  creating a prescription",
      "put": {
        "tags": [
          "prescription"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "update slots",
        "description": "update a prescription",
        "operationId": "update a slots",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          },
          {
            "name": "appointmentId",
            "in": "path",
            "description": "id of appointmentId",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "id of appointmentId"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updatePrescriptionResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deleteprescription":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about deleteprescription",
      "description": "  delete a deleteprescription",
      "post": {
        "tags": [
          "deleteprescription"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a prescription",
        "description": "delete a prescription",
        "operationId": "delete a deleteprescription",
        "requestBody": {
          "description": "The new deleteprescription to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deleteprescriptions"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteprescriptionsResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/invitees":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about invitees",
      "description": "  delete a invitees",
      "post": {
        "tags": [
          "invitees"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a invitees",
        "description": "create a invitees",
        "operationId": "create a invitees",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          }
        ],
        "requestBody": {
          "description": "The new invitees to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createInvite"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createInviteResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "get": {
        "tags": [
          "invitees"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the invitees",
        "description": "Returns the invitees",
        "operationId": "invitees",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all invitee",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/getInviteeResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "delete": {
        "tags": [
          "invitees"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a invitees",
        "description": "delete a invitees",
        "operationId": "delete a invitees",
        "requestBody": {
          "description": "The new invitees to delete",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deleteInvite"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteInviteResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/deleteinvitees":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about deleteinvitees",
      "description": "  deleteinvitees",
      "delete": {
        "tags": [
          "deleteinvitees"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a deleteinvitees",
        "description": "delete a deleteinvitees",
        "operationId": "delete a deleteinvitees",
        "requestBody": {
          "description": "The new deleteinvitees to delete",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deleteinvitees"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deleteinviteesResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/waitingroom":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about get a waitingroom",
      "description": "  get a waitingroom",
      "get": {
        "tags": [
          "waitingroom"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "Get all the waitingroom",
        "description": "Returns the waitingroom",
        "operationId": "waitingroom",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token"
              }
          }
        ],
        "responses": {
          "200": {
            "description": "Succesfully returned all chat",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/waitingroomResponseResponse"
                  }
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    },
    "/doctorsign":{
      "servers": [
        {
          "url": "https://iu7r8rlgih.execute-api.ap-southeast-1.amazonaws.com/develop"
        }
      ],
      "summary": "Operations about invitees",
      "description": "  delete a invitees",
      "post": {
        "tags": [
          "doctorsign"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "creaate a doctorsign",
        "description": "create a doctorsign",
        "operationId": "create a doctorsign",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          }
        ],
        "requestBody": {
          "description": "The new invitees to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/createdoctorsign"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/createdoctorsignResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "delete": {
        "tags": [
          "doctorsign"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "delete a invitees",
        "description": "delete a invitees",
        "operationId": "delete a invitees",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of user"
              }
          }
        ],
        "requestBody": {
          "description": "The new invitees to delete",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/deletedoctorssign"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/deletedoctorssignResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      },
      "put": {
        "tags": [
          "doctorsign"
        ],
        "security": [
          {
            "bearerAuth": []
          }
        ],
        "summary": "update a doctorsign",
        "description": "update a doctorsign",
        "operationId": "update a doctorsign",
        "parameters": [
          {
            "name": "token",
            "in": "header",
            "description": "token of the user",
            "style": "simple",
            "required": true,
            "schema": {
              "type": "string",
              "description": "token of the user"
              }
          }
        ],
        "requestBody": {
          "description": "The new invitees to add",
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/updatedoctorsign"
              }
            }
          }
        },
        "responses": {
          "200": {
            "description": "Success",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/updatedoctorsignResponse"
                }
              }
            }
          },
          "4XX": {
            "description": "Bad Request"
          },
          "5XX": {
            "description": "Internal Server Error"
          },
          "default": {
            "description": "Success"
          }
        }
      }
    }
  },
  "components": {
    "schemas": {
      "deleteUser":{
         "properties": {
           "username":{
              "type":"string",
              "description": "id of the user"
           }
        },
        "description": "Represents a delete user",
        "example":{
          "username":"8d4b3020-60dc-11ed-a9be-fd0de994d756"
        }
      },
      "deleteUserResponse":{
          "description": "delete user response",
          "example":{
              "status": "true",
              "data": "user deleted successfully"
          }
      },
      "getCount":{
        "type": "object",
        "description": "get the user count",
        "example":{
          "status": true,
          "data": {
            "consultationsCount": 0
          }
        }
      },
      "getUnderCorporateCount":{
        "type":"object",
        "description":"get the undercorporatecount",
        "example":{
            "status": true,
            "data": {
              "consultantCount": 0,
              "userCount": 3
          }
        }       
      },
      "UpdateUser": {
        "type": "object",
        "properties": {
          "consultRole": {
            "type": "string",
            "description": "role of the consultant"
          },
          "corporateId":{
            "type": "string",
            "description": "id of the corporate"
          },
          "email":{
            "type": "string",
            "description": "id of the email"
          },
          "firstName":{
            "type": "string",
            "description": "firstname of the user"
          },
          "lastName":{
            "type": "string",
            "description": "lastname of the user"
          },
          "corporateName":{
            "type": "string",
            "description": "name of the corporate"
          }

        },
        "description": "Represents a update of user",
        "example": {
          "consultRole":"1",
          "corporateId":"2",
          "email":"3",
          "firstName":"4",
          "lastName":"5",
          "corporateName":"6"
        }
      },
      "updateUsersResponse":{
        "description": "response about the updateuser",
        "example":{
          "status":"true",
          "data":"response"
        }
      },
      "getAdminUserReport":{
        "type":"object",
        "description":"get the undercorporatecount",
        "example":{
          "response":{
            "status": true,
            "data": {
              "consultant": 13,
              "corporate": 4,
              "todayuser": 0,
              "totaluser": 11,
              "todaypendingappointment": 0,
              "todaypastappointment": 0,
              "todaycancelledappointments": 0,
              "upcomingappointments": 0,
              "todaysuccesscall": 0
            }
          }
        }       
      },
      "getAdminAppointmentReport":{
        "type":"object",
        "description":"get the AdminAppointmentReport",
        "example":{
            "status": true,
            "data": {
              "todaypendingappointment": 0,
              "todaycancelledappointments": 0,
              "upcomingappointments": 0,
              "todayRejectedAppointments": 0
            }
        } 
      },
      "getCorporateDashboard":{
        "type":"object",
        "description":"get the getCorporateDashboard",
        "example":{
          "response":{
              "status": true,
              "data": {
                "consultants": 0,
                "todayusers": 0,
                "totalusers": 11,
                "todaypendingappointments": 0,
                "todaypastappointments": 0,
                "todaycancelledappointments": 0,
                "upcomingappointments": 0,
                "todaysuccessfullcalls": 0
              }
          }
        } 
      },
      "getCorporateuserReport":{
        "type":"object",
        "description":"get the getCorporateuserReport",
        "example":{
          "response":{
            "status": true,
            "data": {
              "todayuser": 0,
              "totaluser": 0
            }
          }
        } 
      },
      "getCorporateAppointmentReport":{
        "type":"object",
        "description":"get the getCorporateuserReport",
        "example":{
          "response":{
            "status": true,
            "data": {
              "todaypendingappointment": 0,
              "todaycancelledappointments": 0,
              "upcomingappointments": 0,
              "todayRejectedAppointments": 0
            }
          }
        } 
      },
      "getAdminConsultantReport":{
        "type":"object",
        "description":"get the getAdminConsultantReport",
        "example":{
          "status": true,
          "data": [
            {
              "_id": "636be69eeb30d3afaa0df292",
              "consultantTypes": [
                "Legal_Consultant"
              ],
              "businessProfiles": [
                {
                  "businessName": "",
                  "consultantType": "Legal_Consultant",
                  "designation": ""
                }
              ],
              "languages": [],
              "emailVerified": true,
              "userId": "f0955ac0-6055-11ed-a97e-337e329b11a8",
              "createdAt": 1668015774413,
              "updatedDate": 1668601313459,
              "consultRole": "consultant",
              "search_term": "",
              "consultId": "CO46500",
              "assignedTo": "d71f348d-e74e-4ce7-9328-b998315616da",
              "firstName": "krishna",
              "email": "testconsult@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "currency": "INR",
              "updatedAt": "2022-11-16T12:21:54.031Z",
              "__v": 0,
              "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJmMDk1NWFjMC02MDU1LTExZWQtYTk3ZS0zMzdlMzI5YjExYTgiLCJzdWJkb21haW4iOiJ0ZXN0YXBwIiwiZW1haWwiOiJ0ZXN0Y29uc3VsdEB5b3BtYWlsLmNvbSIsImNvbnN1bHRSb2xlIjoiY29uc3VsdGFudCIsInNlc3Npb25JZCI6IjY2ZjY0MjgwLTYzZWMtMTFlZC1iNzVjLTZmODA0ZTBkNjlkYyIsImlhdCI6MTY2ODQxMDI1MCwiZXhwIjoxNjY4NDk2NjUwfQ.YZQLBbUHW0DomEflIsKzsHVy_p9zPMwSZKpMIExKV4Q",
              "confirmed": true
            },
            {
              "_id": "636c8e4eed2d23000847cc12",
              "consultantTypes": [
                "Legal_Consultant"
              ],
              "businessProfiles": [
                {
                  "businessName": "",
                  "consultantType": "Legal_Consultant",
                  "designation": "",
                  "consultantSubType": "Intellectual_Property_Lawyer"
                }
              ],
              "languages": [],
              "emailVerified": true,
              "userId": "e38d2dd0-60b9-11ed-b253-7f3fcd03dbb6",
              "createdAt": 1668058702321,
              "updatedDate": 1668058702321,
              "consultRole": "consultant",
              "search_term": "",
              "consultId": "CO83338",
              "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "firstName": "healthconsone",
              "email": "healthconsone@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "currency": "INR",
              "updatedAt": "2022-11-10T05:48:03.328Z",
              "__v": 0
            },
            {
              "_id": "636c945a7876fe0008e33323",
              "consultantTypes": [
                "Education_Consultant"
              ],
              "businessProfiles": [
                {
                  "businessName": "",
                  "consultantType": "Education_Consultant",
                  "designation": "",
                  "consultantSubType": "Vocational_Counselling"
                }
              ],
              "languages": [],
              "emailVerified": true,
              "userId": "7e1d2c80-60bd-11ed-9d21-5be7d9ea2c8c",
              "createdAt": 1668060250122,
              "updatedDate": 1668060250122,
              "consultRole": "consultant",
              "search_term": "",
              "consultId": "CO33000",
              "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "firstName": "vocalconsultant",
              "email": "vocalconsultant@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "currency": "INR",
              "updatedAt": "2022-11-10T06:05:25.848Z",
              "__v": 0
            },
            {
              "_id": "636ca62f9afd6400080391df",
              "consultantTypes": [
                "Legal_Consultant"
              ],
              "businessProfiles": [
                {
                  "businessName": "",
                  "consultantType": "Legal_Consultant",
                  "designation": "",
                  "consultantSubType": "Intellectual_Property_Lawyer"
                }
              ],
              "languages": [],
              "emailVerified": true,
              "userId": "1f6cc0a0-60c8-11ed-99e6-9f2511096b5f",
              "createdAt": 1668064815724,
              "updatedDate": 1668064815724,
              "consultRole": "consultant",
              "search_term": "",
              "consultId": "CO13480",
              "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "firstName": "krishna",
              "email": "testyopmail@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "currency": "INR",
              "updatedAt": "2022-11-10T07:22:34.303Z",
              "__v": 0
            },
            {
              "_id": "636cde1c6c5a440008f0c53e",
              "consultantTypes": [
                "Legal_Consultant"
              ],
              "businessProfiles": [
                {
                  "businessName": "",
                  "consultantType": "Legal_Consultant",
                  "designation": "",
                  "consultantSubType": "Public_Interest_Lawyer"
                }
              ],
              "languages": [],
              "emailVerified": true,
              "userId": "7506f4b0-60e9-11ed-a0fe-e9ff806ceaaf",
              "createdAt": 1668079132731,
              "updatedDate": 1668079132731,
              "consultRole": "consultant",
              "search_term": "",
              "consultId": "CO2804",
              "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "firstName": "testcons",
              "email": "testcons@yopmail.com",
              "password": "3375a667eba42a52361d28e12d602ff8",
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "currency": "INR",
              "updatedAt": "2022-11-10T11:20:43.392Z",
              "__v": 0
            },
            {
              "_id": "636cdf845ba91c0008e4e4b8",
              "consultantTypes": [
                "Legal_Consultant"
              ],
              "businessProfiles": [
                {
                  "businessName": "",
                  "consultantType": "Legal_Consultant",
                  "designation": "",
                  "consultantSubType": "Intellectual_Property_Lawyer"
                }
              ],
              "languages": [],
              "emailVerified": true,
              "userId": "4bbaa3d0-60ea-11ed-ac3d-af053cc01513",
              "createdAt": 1668079492945,
              "updatedDate": 1668079492945,
              "consultRole": "consultant",
              "search_term": "",
              "consultId": "CO50265",
              "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "firstName": "testconsone",
              "email": "testconsone@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "currency": "INR",
              "updatedAt": "2022-11-10T11:42:39.660Z",
              "__v": 0
            },
            {
              "_id": "63720d7ecf4d96e75d6c94de",
              "userId": "a3ad13c0-6400-11ed-9370-0f21fd809a26",
              "consultRole": "consultant",
              "email": "pplc@yopmail.com",
              "phone": "",
              "createdAt": 1668418942716,
              "updatedDate": 1668418942716,
              "gender": "",
              "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
              "firstName": "Peoplelink Unified",
              "title": "",
              "businessName": "",
              "consultantTypes": [
                null
              ],
              "consultantSubType": "Criminal_Lawyer",
              "designation": "",
              "consultId": "CO36257",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "businessProfiles": [],
              "subdomain": "testapp",
              "currency": "inr",
              "timeZone": "Asia/Kolkata",
              "languages": [],
              "emailVerified": false,
              "updatedAt": "2022-11-14T09:42:22.716Z",
              "__v": 0
            },
            {
              "_id": "63720e51cf4d96e75d6c94e8",
              "userId": "217fec50-6401-11ed-9370-0f21fd809a26",
              "consultRole": "consultant",
              "email": "pplcon@yopmail.com",
              "phone": "",
              "createdAt": 1668419153813,
              "updatedDate": 1668419153813,
              "gender": "",
              "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
              "firstName": "Peoplelink Unified",
              "title": "",
              "businessName": "",
              "consultantTypes": [
                null
              ],
              "consultantSubType": "Psychiatrists",
              "designation": "",
              "consultId": "CO76716",
              "password": "d263b26b3121f839f8414dc9d7291e94",
              "businessProfiles": [],
              "subdomain": "testapp",
              "currency": "inr",
              "timeZone": "Asia/Kolkata",
              "languages": [],
              "emailVerified": false,
              "updatedAt": "2022-11-14T09:45:53.813Z",
              "__v": 0
            },
            {
              "_id": "6374b0fade2a8ae9a49a1365",
              "userId": "42125910-6593-11ed-b8c2-032a4e78911e",
              "consultRole": "consultant",
              "email": "conrob@yopmail.com",
              "phone": "",
              "createdAt": 1668591866146,
              "updatedDate": 1668591866146,
              "gender": "",
              "assignedTo": "76881510-658c-11ed-8c29-4f7ef94c6cff",
              "firstName": "Robort",
              "title": "",
              "businessName": "",
              "consultantTypes": [
                null
              ],
              "consultantSubType": "Public_Interest_Lawyer",
              "designation": "",
              "consultId": "CO34123",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "businessProfiles": [],
              "subdomain": "inccorp",
              "currency": "inr",
              "timeZone": "Asia/Kolkata",
              "languages": [],
              "emailVerified": false,
              "updatedAt": "2022-11-16T09:44:26.146Z",
              "__v": 0
            },
            {
              "_id": "6374b315de2a8ae9a49a136f",
              "userId": "834fbe80-6594-11ed-b8c2-032a4e78911e",
              "consultRole": "consultant",
              "email": "nayasa@yopmail.com",
              "phone": "",
              "createdAt": 1668592405096,
              "updatedDate": 1668592405096,
              "gender": "",
              "assignedTo": "76881510-658c-11ed-8c29-4f7ef94c6cff",
              "firstName": "Nayasa",
              "title": "",
              "businessName": "",
              "consultantTypes": [
                null
              ],
              "consultantSubType": "Psychiatrists",
              "designation": "",
              "consultId": "CO81911",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "businessProfiles": [],
              "subdomain": "inccorp",
              "currency": "inr",
              "timeZone": "Asia/Kolkata",
              "languages": [],
              "emailVerified": true,
              "updatedAt": "2022-11-18T10:46:14.476Z",
              "__v": 0,
              "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI4MzRmYmU4MC02NTk0LTExZWQtYjhjMi0wMzJhNGU3ODkxMWUiLCJzdWJkb21haW4iOiJpbmNjb3JwIiwiZW1haWwiOiJuYXlhc2FAeW9wbWFpbC5jb20iLCJjb25zdWx0Um9sZSI6ImNvbnN1bHRhbnQiLCJzZXNzaW9uSWQiOiIzOTNjNDBjMC02NzJlLTExZWQtOWZiZi04MzRkYzRiYWI0OTciLCJpYXQiOjE2Njg3NjgzNzQsImV4cCI6MTY2ODg1NDc3NH0.U7gK9QIhbp4e2HKOfcfdmCGPP4-UfjoqRR_PLj7-slo"
            }
          ]
        }
      },
      "getAdminAppointmentReportByRole":{
        "type":"object",
        "description":"get the getAdminAppointmentReportByRole",
        "example":{
          "status": true,
          "data": [
            {
              "_id": "636be690eb30d3afaa0df28a",
              "consultantTypes": [],
              "businessProfiles": [],
              "languages": [],
              "emailVerified": true,
              "userId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
              "createdAt": 1668015760544,
              "updatedDate": 1668015760544,
              "consultRole": "corporate",
              "search_term": "",
              "corporateName": "pavan",
              "contactName": "pavan",
              "consultId": "C86801",
              "consultantsCount": 5,
              "gender": "male",
              "firstName": "pavan",
              "expiryAt": 1669225360544,
              "email": "testuser@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "pavan",
              "timeZone": "Asia/Calcutta",
              "currency": "inr",
              "updatedAt": "2022-11-10T10:03:55.814Z",
              "__v": 0,
              "appointment": {
                "confirmedCount": 0,
                "pendingCount": 0,
                "cancelCount": 0
              }
            },
            {
              "_id": "636be874eb30d3afaa0df299",
              "consultantTypes": [],
              "businessProfiles": [],
              "languages": [],
              "emailVerified": true,
              "userId": "1c051b4a-5b96-405e-acca-5d74855caba4",
              "phone": "7815842440",
              "createdAt": 1668016244181,
              "updatedDate": 1668016244181,
              "consultRole": "corporate",
              "search_term": "",
              "consultId": "C11710",
              "consultantsCount": 500,
              "gender": "male",
              "firstName": "Clinic",
              "expiryAt": 1669225844181,
              "email": "venkatesh.t@peoplelinkvc.com",
              "countryCode": "91",
              "city": "Hyd",
              "pincode": "500015",
              "country": "India",
              "address": "testaddress",
              "state": "Bihar",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "testapp",
              "currency": "inr",
              "updatedAt": "2022-11-11T13:47:02.578Z",
              "__v": 0,
              "appointment": {
                "confirmedCount": 0,
                "pendingCount": 0,
                "cancelCount": 0
              }
            },
            {
              "_id": "637223f914b6c6000852eb37",
              "consultantTypes": [],
              "businessProfiles": [],
              "languages": [],
              "emailVerified": false,
              "userId": "09cbbbe0-640e-11ed-9304-f79ae861ecea",
              "createdAt": 1668424697696,
              "updatedDate": 1668424697696,
              "consultRole": "corporate",
              "search_term": "",
              "corporateName": "internet ",
              "contactName": "sandep ",
              "consultId": "C37711",
              "consultantsCount": 0,
              "gender": "male",
              "firstName": "sandep ",
              "expiryAt": 1669634297696,
              "email": "net@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "net",
              "timeZone": "Asia/Kolkata",
              "currency": "inr",
              "updatedAt": "2022-11-14T11:18:17.696Z",
              "__v": 0,
              "appointment": {
                "confirmedCount": 0,
                "pendingCount": 0,
                "cancelCount": 0
              }
            },
            {
              "_id": "6374a593214bdf0008fff3dd",
              "consultantTypes": [],
              "businessProfiles": [],
              "languages": [],
              "emailVerified": true,
              "userId": "76881510-658c-11ed-8c29-4f7ef94c6cff",
              "createdAt": 1668588947861,
              "updatedDate": 1668588947861,
              "consultRole": "corporate",
              "search_term": "",
              "corporateName": "IncCorp",
              "contactName": "Rohit ",
              "consultId": "C11111",
              "consultantsCount": 0,
              "gender": "male",
              "firstName": "Rohit ",
              "expiryAt": 1669798547861,
              "email": "inccorp@yopmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "subdomain": "inccorp",
              "timeZone": "Asia/Kolkata",
              "currency": "inr",
              "updatedAt": "2022-11-21T07:16:52.466Z",
              "__v": 0,
              "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI3Njg4MTUxMC02NThjLTExZWQtOGMyOS00ZjdlZjk0YzZjZmYiLCJzdWJkb21haW4iOiJpbmNjb3JwIiwiZW1haWwiOiJpbmNjb3JwQHlvcG1haWwuY29tIiwiY29uc3VsdFJvbGUiOiJjb3Jwb3JhdGUiLCJzZXNzaW9uSWQiOiI3OGVlNmZmMC02OTZjLTExZWQtYTFiYy05MWQ2M2QyMjVmYzAiLCJpYXQiOjE2NjkwMTUwMTIsImV4cCI6MTY2OTEwMTQxMn0.vgPQEH8HV-ucigqiEAtDgSjbFc0oN3n-hMjiuB8FV-g",
              "appointment": {
                "confirmedCount": 0,
                "pendingCount": 0,
                "cancelCount": 0
              }
            }
          ]
        }
      },
      "verifyUserResponse":{
        "type":"object",
        "description":"get the verifyUserResponse",
        "example":{
          "response":{
            
              "status": true,
              "data": {
                "consultantTypes": [],
                "businessProfiles": [],
                "languages": [],
                "emailVerified": true,
                "_id": "636be690eb30d3afaa0df28a",
                "userId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "createdAt": 1668015760544,
                "updatedDate": 1669017549713,
                "consultRole": "corporate",
                "search_term": "",
                "corporateName": "pavan",
                "contactName": "pavan",
                "consultId": "C86801",
                "consultantsCount": 5,
                "gender": "male",
                "firstName": "pavan",
                "expiryAt": 1669225360544,
                "email": "testuser@yopmail.com",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "subdomain": "pavan",
                "timeZone": "Asia/Calcutta",
                "currency": "inr",
                "updatedAt": "2022-11-21T07:59:09.713Z",
                "__v": 0,
                "confirmed": true
              }
            }
          
        }
      },
      "createAdmin":{
      "type": "object",
      "properties": {
        "consultRole": {
          "type": "string",
          "description": "role of the consultant"
        },
        "firstName": {
          "type": "string",
          "description": "name of the admin"
        },
        "email": {
          "type": "string",
          "description": "email of the user"
        }
      },
      "description": "about creation of stripe",
      "example": {
        "consultRole":"corporate",
        "firstName":"subbarao",
        "email":"subbarao@gmail.com"
      }
    },
    "createAdminResponse":{
      "type":"object",
      "description":"get the createAdminResponse",
      "example":{
        "response":{
          
            "status": true,
            "data": {
              "userId": "3e304620-6973-11ed-8af0-dfb37904e8be",
              "createdAt": 1669017920612,
              "updatedDate": 1669017920612,
              "consultRole": "corporate",
              "search_term": "",
              "consultId": "C13919",
              "consultantsCount": 5,
              "gender": "male",
              "firstName": "subbarao",
              "expiryAt": 1670227520612,
              "email": "subbarao@gmail.com",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "currency": "inr"
            
          }
          }
        
      }
    },
     "saveLogoResponse":{
      "type":"object",
      "description":"save the saveLogoResponse",
      "example":{
        "response":{
          "status": true,
          "data": {
            "_id": "636be690eb30d3afaa0df287",
            "corporateId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
            "subdomain": "pavan",
            "name": "pavan",
            "createdAt": 1668015760456,
            "updatedAt": "2022-11-21T08:22:51.026Z",
            "__v": 0,
            "logo": "pacan"
          }
        }
      }
    },
    "getListDomain":{
      "type":"object",
      "description":"get the getListDomain",
      "example":{
        "response":{
          "status": true,
          "data": {
            "_id": "636be690eb30d3afaa0df287",
            "corporateId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
            "subdomain": "pavan",
            "name": "pavan",
            "createdAt": 1668015760456,
            "updatedAt": "2022-11-21T08:22:51.026Z",
            "__v": 0,
            "logo": "pacan"
          }
        }
      }
    },
    "deleteStripeResponse":{
      "type":"object",
      "description":"deleteStripeResponse",
      "example":{
        "response":{
          "data":"Deleted Successfully"
        }
      }
    },
    "getlistStripe":{
      "type":"object",
      "description":"get the getlistStripe",
      "example":{
        "response":{
          "data":"result || no data found"
        }
      }
    },
    "createStripe":{
      "type": "object",
      "properties": {
        "clientstripekey": {
          "type": "string",
          "description": "key of the clientstripekey"
        },
        "serverstripekey": {
          "type": "string",
          "description": "key of the serverstripekey"
        }
      },
      "description": "about creation of stripe",
      "example": {
        "clientstripekey": "1",
        "serverstripekey": "2"
      }
    },
    "createStripeResponse":{
      "type":"object",
      "description":"createStripeResponse",
      "example":{
        "response":{
          "status": true,
          "data": {
            "n": 1,
            "electionId": "7fffffff000000000000019f",
            "opTime": {
              "ts": "7168391328596754458",
              "t": 415
            },
            "upserted": [
              {
                "index": 0,
                "_id": "637b3def1fd6436bb87c6ce6"
              }
            ],
            "nModified": 0,
            "ok": 1,
            "$clusterTime": {
              "clusterTime": "7168391328596754458",
              "signature": {
                "hash": "+hnOpNWaR/mNA4REPP+vW9kytpw=",
                "keyId": "7115152610507620377"
              }
            },
            "operationTime": "7168391328596754458"
          }
        }
      }
    },
    "deleteLogo":{
      "type": "object",
      "properties": {
        "subdomain": {
          "type": "string",
          "description": "name of the subdomain"
        }
      },
      "example":{
        "subdomain":"1"
      }
    },
    "deleteLogoResponse":{
      "type":"object",
      "description":"deleteLogo",
      "example":{
        "response":{
          
            "status": true,
            "data": {
              "_id": "637b310ebe340e815d5f940e",
              "corporateId": "205acad0-6973-11ed-8af0-dfb37904e8be",
              "createdAt": 1669017870381,
              "updatedAt": "2022-11-21T09:45:00.163Z",
              "__v": 0,
              "logo": null
            }
          
        }
      }
    },
    "createFreeLicense":{
      "type": "object",
      "properties": {
        "consultRole": {
          "type": "string",
          "description": ""
        },
        "email": {
          "type": "string",
          "description": "email of the user"
        },
        "suddomain": {
          "type": "string",
          "description": "email of the user"
        },
        "consultantType": {
          "type": "string",
          "description": "types of the consultant"
        },
        "userId": {
          "type": "string",
          "description": "types of the consultant"
        }
      },
      "description": "about creation freelicense",
      "example": {
        "consultRole": "1",
        "email": "2",
        "suddomain":"3",
        "consultantType":"4",
        "userId":"5"
      }
    },
    "createFreeLicenseResponse":{
      "type":"object",
      "description":"deleteLogo",
      "example":{
        "response":{
          "data":"freepay.userId"
        }
      }
    },
    "createSignin":{
      "type": "object",
      "properties": {
        "subdomain": {
          "type": "string",
          "description": " value of subdomain"
        },
        "email": {
          "type": "string",
          "description": "email of the user"
        },
        "countersign": {
          "type": "string",
          "description": "password of the user"
        }
      },
      "description": "about creation freelicense",
      "example": {
        "subdomain": "pavan",
        "email": "test@yopmail.com",
        "countersign":"InConsult@123"
      }
    },
    "createSigninResponse":{
      "type":"object",
      "description":"createSignin",
      "example":{
        "response":{
          
            "status": true,
            "data": "BearereyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJmMDk1NWFjMC02MDU1LTExZWQtYTk3ZS0zMzdlMzI5YjExYTgiLCJzdWJkb21haW4iOiJ0ZXN0YXBwIiwiZW1haWwiOiJ0ZXN0Y29uc3VsdEB5b3BtYWlsLmNvbSIsImNvbnN1bHRSb2xlIjoiY29uc3VsdGFudCIsInNlc3Npb25JZCI6ImY3ZmIwYTkwLTY5NzgtMTFlZC1hYjUyLTk3NzI2ZThkNWQyZiIsImlhdCI6MTY2OTAyMDM3OSwiZXhwIjoxNjY5MTA2Nzc5fQ.6g7diTGIJGf33LF3l_tkJPEo5wKHh9RDg9PyT9LX7pE"
      
        }
      }
    },
    "createSendOtp":{
      "type": "object",
      "properties": {
        "subdomain": {
          "type": "string",
          "description": " value of subdomain"
        },
        "email": {
          "type": "string",
          "description": "email of the user"
        }
      },
      "description": "about creation freelicense",
      "example": {
        "subdomain": "pavan",
        "email": "testapp@yopmail.com"
      }
    },
    "createSendOtpResponse":{
      "type":"object",
      "description":"createSignin",
      "example":{
        "response":{
          "data":"OTP  send successfully"
        }
      }
    },
    "verifyOTP":{
      "type": "object",
      "properties": {
        "otp": {
          "type": "string",
          "description": " otp  value"
        },
        "email": {
          "type": "string",
          "description": "email of the user"
        },
        "subdomain":{
          "type":"string",
          "description": "subdomain name"
        },
        "emailVerified":{
          "type": "string",
          "description": "either true or false"
        },
        "mobileType":{
          "type": "string",
          "description": "type of the mobile"
        },
        "userId":{
          "type":"string",
          "description":"id of the user"
        }
        
      },
      "description": "about creation freelicense",
      "example": {
        "subdomain": "1",
        "email": "2",
        "otp":"123454",
        "emailVerified":"true",
        "mobileType":"3",
        "userId":"4"
      }
    },
    "verifyOTPResponse":{
      "type":"object",
      "description":"verify  otp",
      "example":{
        "response":{
          "status": "true",
          "data":"jwt token {or} Verification Done successfully"
        }
      }
    },
    "changePassword":{
      "type": "object",
      "properties": {
        "otp": {
          "type": "string",
          "description": " otp  value"
        },
        "token": {
          "type": "string",
          "description": "token of the user"
        },
        "password": {
          "type": "string",
          "description": "password of the user"
        },
        "subdomain":{
          "type": "string",
          "description": "subdomain name"   
        },
        "email":{
          "type": "string",
          "description": "email of the user"   
        }
      },
      "description": "about creation freelicense",
      "example": {
        "subdomain": "1",
        "email": "2",
        "otp":"123454",
        "token":"3",
        "password":"12345"
      }
    },
    "changePasswordResponse":{
      "type":"object",
      "description":"change password",
      "example":{
        "response":{
          "status": "true",
          "data":"Verification Done successfully"
        }
      }
    },
    "getUserResponse":{
      "type":"object",
      "description":"get the getlistStripe",
      "example":{
        "response":{
          "data":"getUser"
        }
      }
    },
    "createRefreshTokenResponse":{
      "type":"object",
      "description":"change password",
      "example":{
        "response":{
          "status": "true",
          "data":"jwt token"
        }
      }
    },
    "getCousultantListResponse":{
      "type":"object",
      "description":"get the CousultantList",
      "example":{
        "response":{
          "data":{
            "status": true,
            "data": [
              {
                "_id": "636e159729498df7cfd00261",
                "userId": "1ce66c60-61a3-11ed-a64f-efa0b6125b19",
                "consultRole": "user",
                "email": "sandeep123@yopmail.com",
                "phone": "",
                "createdAt": 1668158871078,
                "updatedDate": 1668158871078,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "sandeep",
                "title": "",
                "consultantTypes": [],
                "consultId": "U81726",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-11T09:29:22.293Z",
                "__v": 0
              },
              {
                "_id": "6371d7aa84368caecb53440e",
                "userId": "8dc8bac0-63e0-11ed-9154-27f0cdfd6430",
                "consultRole": "user",
                "email": "unifiedpeoplelink@gmail.com",
                "phone": "",
                "createdAt": 1668405162092,
                "updatedDate": 1668405162092,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U23073",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T05:52:42.092Z",
                "__v": 0
              },
              {
                "_id": "6371d90e2bcdbd95ac051142",
                "userId": "620c0620-63e1-11ed-8b96-e9d3d0360340",
                "consultRole": "user",
                "email": "sandeep.k@peoplelinkvc.com",
                "phone": "",
                "createdAt": 1668405518210,
                "updatedDate": 1668405518210,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "sandeep kumar",
                "title": "",
                "consultantTypes": [],
                "consultId": "U39271",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T05:58:38.210Z",
                "__v": 0
              },
              {
                "_id": "6371e25e9bb4deef426bf7dc",
                "userId": "ef44e110-63e6-11ed-87a8-e7082cc7e557",
                "consultRole": "user",
                "email": "sandeepm@yopmail.com",
                "phone": "",
                "createdAt": 1668407902625,
                "updatedDate": 1668407902625,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "sandeep m",
                "title": "",
                "consultantTypes": [],
                "consultId": "U31055",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T06:38:22.625Z",
                "__v": 0
              },
              {
                "_id": "6371e4937c197ff5695da9a9",
                "userId": "400511f0-63e8-11ed-ab05-f5b603aeb2ce",
                "consultRole": "user",
                "email": "pp@yopmail.com",
                "phone": "",
                "createdAt": 1668408467599,
                "updatedDate": 1668408467599,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U62364",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T06:47:47.599Z",
                "__v": 0
              },
              {
                "_id": "6371e60ce47f8191a8b4dcd8",
                "userId": "20db0db0-63e9-11ed-8e99-e9c61398e85c",
                "consultRole": "user",
                "email": "clinic@yopmail.com",
                "phone": "",
                "createdAt": 1668408844811,
                "updatedDate": 1668408844811,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "new clinic",
                "title": "",
                "consultantTypes": [],
                "consultId": "U98506",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T06:54:04.811Z",
                "__v": 0
              },
              {
                "_id": "6371e8e943f2d88c74d78cf5",
                "userId": "d5d64580-63ea-11ed-b28b-b31de30676fd",
                "consultRole": "user",
                "email": "suri@yopmail.com",
                "phone": "",
                "createdAt": 1668409577944,
                "updatedDate": 1668409577944,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Surya ",
                "title": "",
                "consultantTypes": [],
                "consultId": "U94507",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T07:06:17.944Z",
                "__v": 0
              },
              {
                "_id": "6371ed81c8c71e0abcd307ef",
                "userId": "92c9efa0-63ed-11ed-9463-ef043e0f9930",
                "consultRole": "user",
                "email": "pp@yopmail.com",
                "phone": "",
                "createdAt": 1668410753946,
                "updatedDate": 1668410753946,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U72174",
                "password": "ed86360d5d1f16c061c5e75758ee84c9",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-16T08:47:10.305Z",
                "__v": 0,
                "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI5MmM5ZWZhMC02M2VkLTExZWQtOTQ2My1lZjA0M2UwZjk5MzAiLCJzdWJkb21haW4iOiJ0ZXN0YXBwIiwiZW1haWwiOiJwcEB5b3BtYWlsLmNvbSIsImNvbnN1bHRSb2xlIjoidXNlciIsInNlc3Npb25JZCI6IjQyMjY3NmYwLTY1OGItMTFlZC1iOWQ2LWJmMzEyZWZhYjU4ZSIsImlhdCI6MTY2ODU4ODQzMCwiZXhwIjoxNjY4Njc0ODMwfQ.sewf1tP0kPy4tFKdiLRG3pPr6w1BisRCDklR6eVZlP8"
              },
              {
                "_id": "6371f3b91df66928afa94dfa",
                "userId": "47392930-63f1-11ed-bcf0-697badf19f38",
                "consultRole": "user",
                "email": "ppp@yopmail.com",
                "phone": "",
                "createdAt": 1668412345155,
                "updatedDate": 1668412345155,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U27197",
                "password": "7f5d1f7be1a8daa85a89d855bba0122d",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T07:52:25.155Z",
                "__v": 0
              },
              {
                "_id": "6371f44c1df66928afa94dfe",
                "userId": "9edf0ec0-63f1-11ed-bcf0-697badf19f38",
                "consultRole": "user",
                "email": "suri@yopmail.com",
                "phone": "",
                "createdAt": 1668412492204,
                "updatedDate": 1668412492204,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U17709",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T07:54:52.204Z",
                "__v": 0
              }
            ]
          }
        }
      }
    },
    "getCousultantTypeListResponse":{
      "type":"object",
      "description":"get the CousultantTypeList",
      "example":{
        "response":{
          "data":{
            "status": true,
            "count": 0,
            "data": []
          }
        }
      }
    },
    "getUserByPhoneAndSubdomainResponse":{
      "type":"object",
      "description":"get the getUserByPhoneAndSubdomain",
      "example":{
        "response":{
          "data":"userResult || null"
        }
      }
    },
    "getUserDetailResponse":{
      "type":"object",
      "description":"get the getUserDetails",
      "example":{
        "response":{
          "data":"result"
        }
      }
    },
    "updateconsultuser":{
      "type": "object",
      "properties": {
        "email":{
          "type": "string",
          "description": "id of the email"
        },
        "firstName":{
          "type": "string",
          "description": "firstname of the user"
        },
        "lastName":{
          "type": "string",
          "description": "lastname of the user"
        }

      },
      "description": "Represents a update of user",
      "example": {
        "email":"3",
        "firstName":"4",
        "lastName":"5"
      }
    },
    "UpdateConsultantUserResponse":{
      "description": "response about the updateuser",
      "example":{
        "status":"true",
        "data":{
          "status": true,
          "data": {
            "_id": "637dc64bd27e77a986d434ca",
            "userId": "419cd220-6afd-11ed-94ce-03b5c59f0692",
            "consultRole": "user",
            "email": "sandep@yopmail.com",
            "phone": "",
            "createdAt": 1669187147842,
            "updatedDate": 1669219105694,
            "gender": "",
            "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
            "firstName": "sandeep",
            "title": "",
            "consultantTypes": [],
            "consultId": "U76537",
            "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
            "businessProfiles": [
              {}
            ],
            "subdomain": "testapp",
            "timeZone": "Asia/Calcutta",
            "languages": [],
            "emailVerified": true,
            "updatedAt": "2022-11-23T15:58:25.695Z",
            "__v": 0,
            "lastName": "kumar",
            "search_term": " sandeep kumar sandep@yopmail.com"
          }
        }
      }
    },
    "getunlicensedResponse":{
      "type":"object",
      "description":"get the getunlicensed",
      "example":{
        "response":{
          "data":"result"
        }
      }
    },
    "doctoruploadlistResponse":{
      "type":"object",
      "description":"get the doctoruploadlist",
      "example":{
        "response":{
          "data":"result.items"
        }
      }
    },
    "deletewaitingroomupload":{
      "type": "object",
      "properties": {
        "uploadkey":{
          "type": "string",
          "description": "id of the email"
        }
      },
      "description": "Represents a delete of  waitingroomupload",
      "example": {
        "uploadkey":"1"
      }
    },
    "deletewaitingroomuploadResponse":{
      "type":"object",
      "description":"delete the deletewaitingroomuploadResponse",
      "example":{
        "response":{
          "data":"Deleted Successfully"
        }
      }
    },
    "profilepic":{
      "type": "object",
      "properties": {
        "key": {
          "type": "string",
          "description": " key of of the profilepic"
        },
        "url": {
          "type": "string",
          "description": "url of the pic"
        }
      },
      "description": "about creation profilepic",
      "example": {
        "key": "image",
        "url": "localhost.jpg"
      }
    },
    "profilepicResponse":{
      "type":"object",
      "description":"create a profilepicResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": {
              "_id": "637dc64bd27e77a986d434ca",
              "userId": "419cd220-6afd-11ed-94ce-03b5c59f0692",
              "consultRole": "user",
              "email": "sandep@yopmail.com",
              "phone": "",
              "createdAt": 1669187147842,
              "updatedDate": 1669219778091,
              "gender": "",
              "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "firstName": "sandeep",
              "title": "",
              "consultantTypes": [],
              "consultId": "U76537",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "businessProfiles": [
                {}
              ],
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "languages": [],
              "emailVerified": true,
              "updatedAt": "2022-11-23T16:09:38.538Z",
              "__v": 0,
              "lastName": "kumar",
              "search_term": " sandeep kumar sandep@yopmail.com",
              "profileImage": {
                "key": "image",
                "url": "app.inconsult.vc"
              }
            }
          }
        }
      }
    },
    "currentuserinfoResponse":{
      "type":"object",
      "description":"get the currentuserinfo",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": {
              "_id": "637dc64bd27e77a986d434ca",
              "userId": "419cd220-6afd-11ed-94ce-03b5c59f0692",
              "consultRole": "user",
              "email": "sandep@yopmail.com",
              "phone": "",
              "createdAt": 1669187147842,
              "updatedDate": 1669219778091,
              "gender": "",
              "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "firstName": "sandeep",
              "title": "",
              "consultantTypes": [],
              "consultId": "U76537",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "businessProfiles": [
                {}
              ],
              "subdomain": "testapp",
              "timeZone": "Asia/Calcutta",
              "languages": [],
              "emailVerified": true,
              "updatedAt": "2022-11-23T16:09:38.538Z",
              "__v": 0,
              "lastName": "kumar",
              "search_term": " sandeep kumar sandep@yopmail.com",
              "profileImage": {
                "key": "image",
                "url": "app.inconsult.vc"
              }
            }
          }
        }
      }
    },
    "listallcorporatesResponse":{
      "type":"object",
      "description":"get the listallcorporatesResponse",
      "example":{
        "response":{
          "data":{
            "status": true,
            "data": [
              {
                "_id": "636e159729498df7cfd00261",
                "userId": "1ce66c60-61a3-11ed-a64f-efa0b6125b19",
                "consultRole": "user",
                "email": "sandeep123@yopmail.com",
                "phone": "",
                "createdAt": 1668158871078,
                "updatedDate": 1668158871078,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "sandeep",
                "title": "",
                "consultantTypes": [],
                "consultId": "U81726",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-11T09:29:22.293Z",
                "__v": 0
              },
              {
                "_id": "6371d7aa84368caecb53440e",
                "userId": "8dc8bac0-63e0-11ed-9154-27f0cdfd6430",
                "consultRole": "user",
                "email": "unifiedpeoplelink@gmail.com",
                "phone": "",
                "createdAt": 1668405162092,
                "updatedDate": 1668405162092,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U23073",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T05:52:42.092Z",
                "__v": 0
              },
              {
                "_id": "6371d90e2bcdbd95ac051142",
                "userId": "620c0620-63e1-11ed-8b96-e9d3d0360340",
                "consultRole": "user",
                "email": "sandeep.k@peoplelinkvc.com",
                "phone": "",
                "createdAt": 1668405518210,
                "updatedDate": 1668405518210,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "sandeep kumar",
                "title": "",
                "consultantTypes": [],
                "consultId": "U39271",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T05:58:38.210Z",
                "__v": 0
              },
              {
                "_id": "6371e25e9bb4deef426bf7dc",
                "userId": "ef44e110-63e6-11ed-87a8-e7082cc7e557",
                "consultRole": "user",
                "email": "sandeepm@yopmail.com",
                "phone": "",
                "createdAt": 1668407902625,
                "updatedDate": 1668407902625,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "sandeep m",
                "title": "",
                "consultantTypes": [],
                "consultId": "U31055",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T06:38:22.625Z",
                "__v": 0
              },
              {
                "_id": "6371e4937c197ff5695da9a9",
                "userId": "400511f0-63e8-11ed-ab05-f5b603aeb2ce",
                "consultRole": "user",
                "email": "pp@yopmail.com",
                "phone": "",
                "createdAt": 1668408467599,
                "updatedDate": 1668408467599,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U62364",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T06:47:47.599Z",
                "__v": 0
              },
              {
                "_id": "6371e60ce47f8191a8b4dcd8",
                "userId": "20db0db0-63e9-11ed-8e99-e9c61398e85c",
                "consultRole": "user",
                "email": "clinic@yopmail.com",
                "phone": "",
                "createdAt": 1668408844811,
                "updatedDate": 1668408844811,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "new clinic",
                "title": "",
                "consultantTypes": [],
                "consultId": "U98506",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T06:54:04.811Z",
                "__v": 0
              },
              {
                "_id": "6371e8e943f2d88c74d78cf5",
                "userId": "d5d64580-63ea-11ed-b28b-b31de30676fd",
                "consultRole": "user",
                "email": "suri@yopmail.com",
                "phone": "",
                "createdAt": 1668409577944,
                "updatedDate": 1668409577944,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Surya ",
                "title": "",
                "consultantTypes": [],
                "consultId": "U94507",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T07:06:17.944Z",
                "__v": 0
              },
              {
                "_id": "6371ed81c8c71e0abcd307ef",
                "userId": "92c9efa0-63ed-11ed-9463-ef043e0f9930",
                "consultRole": "user",
                "email": "pp@yopmail.com",
                "phone": "",
                "createdAt": 1668410753946,
                "updatedDate": 1668410753946,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U72174",
                "password": "ed86360d5d1f16c061c5e75758ee84c9",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-16T08:47:10.305Z",
                "__v": 0,
                "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI5MmM5ZWZhMC02M2VkLTExZWQtOTQ2My1lZjA0M2UwZjk5MzAiLCJzdWJkb21haW4iOiJ0ZXN0YXBwIiwiZW1haWwiOiJwcEB5b3BtYWlsLmNvbSIsImNvbnN1bHRSb2xlIjoidXNlciIsInNlc3Npb25JZCI6IjQyMjY3NmYwLTY1OGItMTFlZC1iOWQ2LWJmMzEyZWZhYjU4ZSIsImlhdCI6MTY2ODU4ODQzMCwiZXhwIjoxNjY4Njc0ODMwfQ.sewf1tP0kPy4tFKdiLRG3pPr6w1BisRCDklR6eVZlP8"
              },
              {
                "_id": "6371f3b91df66928afa94dfa",
                "userId": "47392930-63f1-11ed-bcf0-697badf19f38",
                "consultRole": "user",
                "email": "ppp@yopmail.com",
                "phone": "",
                "createdAt": 1668412345155,
                "updatedDate": 1668412345155,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U27197",
                "password": "7f5d1f7be1a8daa85a89d855bba0122d",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T07:52:25.155Z",
                "__v": 0
              },
              {
                "_id": "6371f44c1df66928afa94dfe",
                "userId": "9edf0ec0-63f1-11ed-bcf0-697badf19f38",
                "consultRole": "user",
                "email": "suri@yopmail.com",
                "phone": "",
                "createdAt": 1668412492204,
                "updatedDate": 1668412492204,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U17709",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T07:54:52.204Z",
                "__v": 0
              },
              {
                "_id": "63722248ca1e059e4714bdc9",
                "userId": "07a32c00-640d-11ed-bbdd-3bdab620a85e",
                "consultRole": "user",
                "email": "uni@yopmail.com",
                "phone": "",
                "createdAt": 1668424264384,
                "updatedDate": 1668424264384,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U82164",
                "password": "479fb6f357edfea161c48449fe2cf3d6",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-14T11:11:04.384Z",
                "__v": 0
              },
              {
                "_id": "637b5d448f5efdeef44a1aba",
                "userId": "7aa96360-698d-11ed-80ee-85e56ddbcec8",
                "consultRole": "user",
                "email": "incuser@yopmail.com",
                "phone": "",
                "createdAt": 1669029188758,
                "updatedDate": 1669029188758,
                "gender": "",
                "assignedTo": "76881510-658c-11ed-8c29-4f7ef94c6cff",
                "firstName": "incuser",
                "title": "",
                "consultantTypes": [],
                "consultId": "U46985",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "inccorp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-21T11:13:08.758Z",
                "__v": 0
              },
              {
                "_id": "637b5e028f5efdeef44a1ac4",
                "userId": "ebfff9c0-698d-11ed-80ee-85e56ddbcec8",
                "consultRole": "user",
                "email": "userinc@yopmail.com",
                "phone": "",
                "createdAt": 1669029378908,
                "updatedDate": 1669029378908,
                "gender": "",
                "assignedTo": "76881510-658c-11ed-8c29-4f7ef94c6cff",
                "firstName": "User incorp",
                "title": "",
                "consultantTypes": [],
                "consultId": "U50923",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "inccorp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-21T11:16:18.908Z",
                "__v": 0
              },
              {
                "_id": "637b5fa6721dffb6e7e71d54",
                "userId": "e658b880-698e-11ed-b58e-1932f2f93fe2",
                "consultRole": "user",
                "email": "userinc1@yopmail.com",
                "phone": "",
                "createdAt": 1669029798920,
                "updatedDate": 1669029798920,
                "gender": "",
                "assignedTo": "76881510-658c-11ed-8c29-4f7ef94c6cff",
                "firstName": "Incorp User",
                "title": "",
                "consultantTypes": [],
                "consultId": "U51577",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "inccorp",
                "languages": [],
                "emailVerified": false,
                "updatedAt": "2022-11-21T11:23:18.920Z",
                "__v": 0
              },
              {
                "_id": "637b5fe2721dffb6e7e71d5e",
                "userId": "0a24b110-698f-11ed-b58e-1932f2f93fe2",
                "consultRole": "user",
                "email": "userinc2@yopmail.com",
                "phone": "",
                "createdAt": 1669029858977,
                "updatedDate": 1669029858977,
                "gender": "",
                "assignedTo": "76881510-658c-11ed-8c29-4f7ef94c6cff",
                "firstName": "Incorp User",
                "title": "",
                "consultantTypes": [],
                "consultId": "U28295",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "inccorp",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-21T11:24:44.092Z",
                "__v": 0
              },
              {
                "_id": "637c7bee915b80a9481bcceb",
                "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
                "consultRole": "user",
                "email": "abyssuser@yopmail.com",
                "phone": "",
                "createdAt": 1669102574096,
                "updatedDate": 1669102574096,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "abyssuser",
                "title": "",
                "consultantTypes": [],
                "consultId": "U25576",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-22T07:37:27.415Z",
                "__v": 0
              },
              {
                "_id": "637c994be6fda2df9a26a265",
                "userId": "d830d830-6a49-11ed-8557-bf0604bf9f1e",
                "consultRole": "user",
                "email": "thirupathi.d@peoplelinkvc.com",
                "phone": "",
                "createdAt": 1669110091059,
                "updatedDate": 1669110091059,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Thirupathi",
                "title": "",
                "consultantTypes": [],
                "consultId": "U14330",
                "password": "9218c32cc68d2e1a4b151ffc87bc6e7c",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-23T05:06:14.069Z",
                "__v": 0,
                "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJkODMwZDgzMC02YTQ5LTExZWQtODU1Ny1iZjA2MDRiZjlmMWUiLCJzdWJkb21haW4iOiJwYXZhbiIsImVtYWlsIjoidGhpcnVwYXRoaS5kQHBlb3BsZWxpbmt2Yy5jb20iLCJjb25zdWx0Um9sZSI6InVzZXIiLCJzZXNzaW9uSWQiOiI4ZGIzMDgyMC02YWVjLTExZWQtYWUzMy0yZDMyNTYxZWZmYjciLCJpYXQiOjE2NjkxNzk5NzQsImV4cCI6MTY2OTI2NjM3NH0.i5UEVaVM1q_USTGElU3RS1nESjspdRWZSeIfMbUQoRo"
              },
              {
                "_id": "637dc64bd27e77a986d434ca",
                "userId": "419cd220-6afd-11ed-94ce-03b5c59f0692",
                "consultRole": "user",
                "email": "sandep@yopmail.com",
                "phone": "",
                "createdAt": 1669187147842,
                "updatedDate": 1669219778091,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "sandeep",
                "title": "",
                "consultantTypes": [],
                "consultId": "U76537",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-23T16:09:38.538Z",
                "__v": 0,
                "lastName": "kumar",
                "search_term": " sandeep kumar sandep@yopmail.com",
                "profileImage": {
                  "key": "image",
                  "url": "app.inconsult.vc"
                }
              },
              {
                "_id": "637ddd50cebedf0d5b044345",
                "userId": "fa04ffb0-6b0a-11ed-8abf-a531c5ee70e9",
                "consultRole": "user",
                "email": "siva@yopmail.com",
                "phone": "",
                "createdAt": 1669193040684,
                "updatedDate": 1669193040684,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Sivakumar ",
                "title": "",
                "consultantTypes": [],
                "consultId": "U79622",
                "password": "9218c32cc68d2e1a4b151ffc87bc6e7c",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-23T10:54:13.519Z",
                "__v": 0,
                "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJmYTA0ZmZiMC02YjBhLTExZWQtOGFiZi1hNTMxYzVlZTcwZTkiLCJzdWJkb21haW4iOiJ0ZXN0YXBwIiwiZW1haWwiOiJzaXZhQHlvcG1haWwuY29tIiwiY29uc3VsdFJvbGUiOiJ1c2VyIiwic2Vzc2lvbklkIjoiMmFkNGI0YzAtNmIxZC0xMWVkLWJiZGYtYjE5NjVmZjM3OTdjIiwiaWF0IjoxNjY5MjAwODUzLCJleHAiOjE2NjkyODcyNTN9.m926vgW76sEEG3RJ8NxN_KwApogyrdqn94_iaX5lMms"
              }
            ]
          }
        }
      }
    },
    "deletefileResponse":{
      "type":"object",
      "description":"get the deletefileResponse",
      "example":{
        "response":{
          "data":"file deleted successfully"
        }
      }
    },
    "userlistbysubResponse":{
      "type":"object",
      "description":"get the userlistbysubResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "_id": "636e159729498df7cfd00261",
                "userId": "1ce66c60-61a3-11ed-a64f-efa0b6125b19",
                "consultRole": "user",
                "email": "sandeep123@yopmail.com",
                "phone": "",
                "createdAt": 1668158871078,
                "updatedDate": 1668158871078,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "sandeep",
                "title": "",
                "consultantTypes": [],
                "consultId": "U81726",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true
              },
              {
                "_id": "6371d7aa84368caecb53440e",
                "userId": "8dc8bac0-63e0-11ed-9154-27f0cdfd6430",
                "consultRole": "user",
                "email": "unifiedpeoplelink@gmail.com",
                "phone": "",
                "createdAt": 1668405162092,
                "updatedDate": 1668405162092,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U23073",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false
              },
              {
                "_id": "6371d90e2bcdbd95ac051142",
                "userId": "620c0620-63e1-11ed-8b96-e9d3d0360340",
                "consultRole": "user",
                "email": "sandeep.k@peoplelinkvc.com",
                "phone": "",
                "createdAt": 1668405518210,
                "updatedDate": 1668405518210,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "sandeep kumar",
                "title": "",
                "consultantTypes": [],
                "consultId": "U39271",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false
              },
              {
                "_id": "6371e25e9bb4deef426bf7dc",
                "userId": "ef44e110-63e6-11ed-87a8-e7082cc7e557",
                "consultRole": "user",
                "email": "sandeepm@yopmail.com",
                "phone": "",
                "createdAt": 1668407902625,
                "updatedDate": 1668407902625,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "sandeep m",
                "title": "",
                "consultantTypes": [],
                "consultId": "U31055",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false
              },
              {
                "_id": "6371e4937c197ff5695da9a9",
                "userId": "400511f0-63e8-11ed-ab05-f5b603aeb2ce",
                "consultRole": "user",
                "email": "pp@yopmail.com",
                "phone": "",
                "createdAt": 1668408467599,
                "updatedDate": 1668408467599,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U62364",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false
              },
              {
                "_id": "6371e60ce47f8191a8b4dcd8",
                "userId": "20db0db0-63e9-11ed-8e99-e9c61398e85c",
                "consultRole": "user",
                "email": "clinic@yopmail.com",
                "phone": "",
                "createdAt": 1668408844811,
                "updatedDate": 1668408844811,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "new clinic",
                "title": "",
                "consultantTypes": [],
                "consultId": "U98506",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false
              },
              {
                "_id": "6371e8e943f2d88c74d78cf5",
                "userId": "d5d64580-63ea-11ed-b28b-b31de30676fd",
                "consultRole": "user",
                "email": "suri@yopmail.com",
                "phone": "",
                "createdAt": 1668409577944,
                "updatedDate": 1668409577944,
                "gender": "",
                "assignedTo": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "firstName": "Surya ",
                "title": "",
                "consultantTypes": [],
                "consultId": "U94507",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "pavan",
                "languages": [],
                "emailVerified": false
              },
              {
                "_id": "6371ed81c8c71e0abcd307ef",
                "userId": "92c9efa0-63ed-11ed-9463-ef043e0f9930",
                "consultRole": "user",
                "email": "pp@yopmail.com",
                "phone": "",
                "createdAt": 1668410753946,
                "updatedDate": 1668410753946,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U72174",
                "password": "ed86360d5d1f16c061c5e75758ee84c9",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": true,
                "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI5MmM5ZWZhMC02M2VkLTExZWQtOTQ2My1lZjA0M2UwZjk5MzAiLCJzdWJkb21haW4iOiJ0ZXN0YXBwIiwiZW1haWwiOiJwcEB5b3BtYWlsLmNvbSIsImNvbnN1bHRSb2xlIjoidXNlciIsInNlc3Npb25JZCI6IjQyMjY3NmYwLTY1OGItMTFlZC1iOWQ2LWJmMzEyZWZhYjU4ZSIsImlhdCI6MTY2ODU4ODQzMCwiZXhwIjoxNjY4Njc0ODMwfQ.sewf1tP0kPy4tFKdiLRG3pPr6w1BisRCDklR6eVZlP8"
              },
              {
                "_id": "6371f3b91df66928afa94dfa",
                "userId": "47392930-63f1-11ed-bcf0-697badf19f38",
                "consultRole": "user",
                "email": "ppp@yopmail.com",
                "phone": "",
                "createdAt": 1668412345155,
                "updatedDate": 1668412345155,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U27197",
                "password": "7f5d1f7be1a8daa85a89d855bba0122d",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false
              },
              {
                "_id": "6371f44c1df66928afa94dfe",
                "userId": "9edf0ec0-63f1-11ed-bcf0-697badf19f38",
                "consultRole": "user",
                "email": "suri@yopmail.com",
                "phone": "",
                "createdAt": 1668412492204,
                "updatedDate": 1668412492204,
                "gender": "",
                "assignedTo": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "firstName": "Peoplelink Unified",
                "title": "",
                "consultantTypes": [],
                "consultId": "U17709",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [],
                "subdomain": "testapp",
                "languages": [],
                "emailVerified": false
              }
            ]
          }
        }
      }
    },
    "createConfirmUser":{
      "type": "object",
      "properties": {
        "firstName": {
          "type": "string",
          "description": "firstName of the user"
        },
        "email": {
          "type": "string",
          "description": "firstName of the user"
        },
        "title": {
          "type": "string",
          "description": "title of the user"
        },
        "consultRole": {
          "type": "string",
          "description": "consultRole of the consult"
        },
        "gender": {
          "type": "string",
          "description": "gender of the user"
        }
      },
      "description": "about creation profilepic",
      "example": {
        "email":"pavan123@gmail.com",
        "subdomain":"pavan",
        "consultRole":"user",
        "firstName":"pavan",
        "title":"kum",
        "phone": 9932234323,
        "gender":"malw",
        "businessProfiles":"parntenr",
        "consultantSubType":"friend",
        "lastName":"ldm",
        "address":"hyder",
        "countryCode":"+91",
        "country":"india",
        "state":"andhra"
      }
    },
    "createConfirmUserResponse":{
      "type":"object",
      "description":"get the createConfirmUser",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": {
              "userId": "0dba40b0-6b4c-11ed-ac11-e3075edfcb15",
              "consultRole": "user",
              "email": "pavan123@gmail.com",
              "phone": "9932234323",
              "createdAt": 1669220991035,
              "updatedDate": 1669220991035,
              "gender": "malw",
              "firstName": "pavan",
              "lastName": "ldm",
              "title": "kum",
              "consultantTypes": [],
              "consultantSubType": "friend",
              "consultId": "U30605",
              "address": "hyder",
              "countryCode": "+91",
              "country": "india",
              "state": "andhra",
              "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
              "businessProfiles": [
                "parntenr"
              ],
              "subdomain": "pavan",
              "languages": [],
              "emailVerified": false,
              "_id": "637e4a7f4366adee0a8fda59",
              "updatedAt": "2022-11-23T16:29:51.035Z",
              "__v": 0
            }
          }
        }
      }
    },
    "createDomainconfirmation":{
      "type": "object",
      "properties": {
        "username": {
          "type": "string",
          "description": "id of the user"
        },
        "domain": {
          "type": "string",
          "description": "domain of the user"
        }
      },
      "description": "about creation createDomainconfirmation",
      "example": {
        "username":"e84e36c0-6055-11ed-a97e-337e329b11a8",
        "domain":"pavan"
      }
    },
    "createDomainconfirmationResponse":{
      "type":"object",
      "description":"get the Domainconfirmation",
      "example":{
        "response":{
          "data": {"status": true}
        }
      }
    },
    "domainlistResponse":{
      "type":"object",
      "description":"get the domainlistResponse",
      "example":{
        "response":{
          "data":  {
            "_id": "636be690eb30d3afaa0df287",
            "corporateId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
            "subdomain": "pavan",
            "name": "pavan",
            "createdAt": 1668015760456,
            "updatedAt": "2022-11-22T07:34:46.800Z",
            "__v": 0,
            "logo": "https://insta-consult.s3-ap-southeast-1.amazonaws.com/consult-logos/consult-logos/1669102482575.jpg"
          }
        }
      }
    },
    "deleteProfilePic":{
      "type": "object",
      "properties": {
        "sub": {
          "type": "string",
          "description": "sub of the user"
        }
      },
      "description": "about delete deleteProfilePic",
      "example": {
        "sub":"1"
      }
    },
    "deleteProfilePicResponse":{
      "type":"object",
      "description":"delete the deleteProfilePicResponse",
      "example":{
        "response":{
          "data":"finalResult.Attributes"
        }
      }
    },
    "countryListResponse":{
      "type":"object",
      "description":"get the countryListResponse",
      "example":{
        "response":{
          "data":"country"
        }
      }
    },
    "stateListResponse":{
      "type":"object",
      "description":"get the stateListResponse",
      "example":{
        "response":{
          "data":"states"
        }
      }
    },
    "diagonisislistResponse":{
      "type":"object",
      "description":"get the diagonisislistResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": {
              "select_diagnosis": {
                "value": "",
                "defaultlabel": "select_diagnosis",
                "en": "Select Diagnosis",
                "hi": "निदान का चयन करें"
              },
              "Acidic_Regurgitation": {
                "value": "Acidic_Regurgitation",
                "en": "Acidic Regurgitation",
                "hi": "अम्लपित्त"
              },
              "Ankle_Arthritis": {
                "value": "Ankle_Arthritis",
                "en": "Ankle Arthritis",
                "hi": "वात कंटक"
              },
              "Anuria": {
                "value": "Anuria",
                "en": "Anuria",
                "hi": "मूत्राघात"
              },
              "Aphasia": {
                "value": "Aphasia",
                "en": "Aphasia",
                "hi": "मूकता"
              },
              "Ascitis": {
                "value": "Ascitis",
                "en": "Ascitis",
                "hi": "जलोदरा"
              },
              "Bell_s_Palsy": {
                "value": "Bell_s_Palsy",
                "en": "Bell's Palsy",
                "hi": "अर्दित"
              },
              "Boniqn_prostatids_of_perplasia": {
                "value": "Boniqn_prostatids_of_perplasia",
                "en": "Boniqn prostatitis of perplasia",
                "hi": "अष्ठिला"
              },
              "Cervical_Spondylosis": {
                "value": "Cervical_Spondylosis",
                "en": "Cervical Spondylosis",
                "hi": "मान्य स्तम्भ"
              },
              "Convulsions": {
                "value": "Convulsions",
                "en": "Convulsions",
                "hi": "आक्षेपक"
              },
              "Diabeties_Mellitus": {
                "value": "Diabeties_Mellitus",
                "en": "Diabetes Mellitus",
                "hi": "मधुमेह"
              },
              "Dyspnoea": {
                "value": "Dyspnoea",
                "en": "Dyspnoea",
                "hi": "शामजा शवाषा"
              },
              "Eczema": {
                "value": "Eczema",
                "en": "Eczema",
                "hi": "विचचिर्क"
              },
              "Emaciation_of_Scapulan_Murcles": {
                "value": "Emaciation_of_Scapulan_Murcles",
                "en": "Emaciation of Scapula Muscles",
                "hi": "अंश शोष"
              },
              "Erythema_Induratum": {
                "value": "Erythema_Induratum",
                "en": "Erythema Induratum",
                "hi": "शतारु"
              },
              "Frozen_Shoulder": {
                "value": "Frozen_Shoulder",
                "en": "Frozen Shoulder",
                "hi": "अवबाहुक"
              },
              "Glossal_Palsy": {
                "value": "Glossal_Palsy",
                "en": "Glossal Palsy",
                "hi": "जिह्वा स्तम्भ"
              },
              "Hemiplegia": {
                "value": "Hemiplegia",
                "en": "Hemiplegia",
                "hi": "पक्षवध"
              },
              "Hysteria": {
                "value": "Hysteria",
                "en": "Hysteria",
                "hi": "अपतंत्रक"
              },
              "Imoetigo": {
                "value": "Imoetigo",
                "en": "Imoetigo",
                "hi": "चर्मदल"
              },
              "Jaundice": {
                "value": "Jaundice",
                "en": "Jaundice",
                "hi": "कामाला"
              },
              "Lepromalous": {
                "value": "Lepromalous",
                "en": "Lepromalous",
                "hi": "औदुम्बर कुष्ठ"
              },
              "Leprosy": {
                "value": "Leprosy",
                "en": "Leprosy",
                "hi": "पुण्डरीक कुष्ठ"
              },
              "Lichenification": {
                "value": "Lichenification",
                "en": "Lichenification",
                "hi": "किरिभ"
              },
              "Lock_Jaw": {
                "value": "Lock_Jaw",
                "en": "Lock Jaw",
                "hi": "हनुगृह"
              },
              "Monoplegia": {
                "value": "Monoplegia",
                "en": "Monoplegia",
                "hi": "खंज"
              },
              "Muscle_Cramps": {
                "value": "Muscle_Cramps",
                "en": "Muscle Cramps",
                "hi": "खल्ली"
              },
              "Non_Lepromalous": {
                "value": "Non_Lepromalous",
                "en": "Non-Lepromalous",
                "hi": "कपाल कुष्ठ"
              },
              "Paralysis": {
                "value": "Paralysis",
                "en": "Paralysis",
                "hi": "पक्षाघात"
              },
              "Paraplegia": {
                "value": "Paraplegia",
                "en": "Paraplegia",
                "hi": "पंगु"
              },
              "Parkinson_Disease": {
                "value": "Parkinson_Disease",
                "en": "Parkinson Disease",
                "hi": "कम्पवात"
              },
              "Peripheral_Neuritis": {
                "value": "Peripheral_Neuritis",
                "en": "Peripheral Neuritis",
                "hi": "पाद दाह"
              },
              "Phagades": {
                "value": "Phagades",
                "en": "Phagades",
                "hi": "विपादिका"
              },
              "Pityriasis_Scaly": {
                "value": "Pityriasis_Scaly",
                "en": "Pityriasis-Scaly",
                "hi": "सेहुआ सिध्म"
              },
              "Pityriasis": {
                "value": "Pityriasis",
                "en": "Pityriasis",
                "hi": "सिध्म"
              },
              "Proriasis": {
                "value": "Proriasis",
                "en": "Proriasis",
                "hi": "एफ कुष्ठ"
              },
              "Radial_Neuritis_OR_Radio_ulhan_Paralysis": {
                "value": "Radial_Neuritis_OR_Radio_ulhan_Paralysis",
                "en": "Radial Neuritis OR Radio ulhan Paralysis",
                "hi": "विशवाची"
              },
              "Renal_Stones": {
                "value": "Renal_Stones",
                "en": "Renal Stones",
                "hi": "अश्मरी"
              },
              "Scabies": {
                "value": "Scabies",
                "en": "Scabies",
                "hi": "पामा"
              },
              "Sciatica": {
                "value": "Sciatica",
                "en": "Sciatica",
                "hi": "ग्रध्रसी"
              },
              "Sino_Arthritis_of_Knee_joint": {
                "value": "Sino_Arthritis_of_Knee_joint",
                "en": "Sino Arthritis of Knee joint",
                "hi": "क्रोवटुशीर्ष"
              },
              "Skin_Rashes": {
                "value": "Skin_Rashes",
                "en": "Skin Rashes",
                "hi": "त्वचा के चकत्ते"
              },
              "Tetani": {
                "value": "Tetani",
                "en": "Tetani",
                "hi": "अपतानक"
              },
              "Tetanus": {
                "value": "Tetanus",
                "en": "Tetanus",
                "hi": "धनुर्स्तम्भ"
              },
              "Xeroderma": {
                "value": "Xeroderma",
                "en": "Xeroderma",
                "hi": "चमरिख्य"
              },
              "whitish_discolouration_&_skin": {
                "value": "whitish_discolouration_&_skin",
                "en": "whitish discolouration  & skin",
                "hi": "पामा"
              },
              "Stiffness_in_Thighs": {
                "value": "Stiffness_in_Thighs",
                "en": "Stiffness in Thighs",
                "hi": "उरुस्थम्ब"
              },
              "Knee_Pain": {
                "value": "Knee_Pain",
                "en": "Knee Pain",
                "hi": "जणू भेडा"
              },
              "Palpitaions": {
                "value": "Palpitaions",
                "en": "Palpitaions",
                "hi": "हरित द्रव"
              },
              "Eye_Pain": {
                "value": "Eye_Pain",
                "en": "Eye Pain",
                "hi": "अक्षि शूल"
              },
              "Back_Pain": {
                "value": "Back_Pain",
                "en": "Back Pain",
                "hi": "पीठ दर्द"
              },
              "Obstruction_of_Voice": {
                "value": "Obstruction_of_Voice",
                "en": "Obstruction of Voice",
                "hi": "वक् संग"
              },
              "Chicken_Pox": {
                "value": "Chicken_Pox",
                "en": "Chicken Pox",
                "hi": "मसूरिका"
              },
              "Parkinson_s_Disease": {
                "value": "Parkinson_s_Disease",
                "en": "Parkinson's Disease",
                "hi": "वेपथु"
              },
              "Fissures": {
                "value": "Fissures",
                "en": "Fissures",
                "hi": "वैपादिका"
              },
              "Anemia": {
                "value": "Anemia",
                "en": "Anemia",
                "hi": "पांडू"
              },
              "Diabetes_Mellitus": {
                "value": "Diabetes_Mellitus",
                "en": "Diabetes Mellitus",
                "hi": "प्रमेहा"
              },
              "Hemorrhoids": {
                "value": "Hemorrhoids",
                "en": "Hemorrhoids",
                "hi": "अर्सस"
              },
              "Fistula": {
                "value": "Fistula",
                "en": "Fistula",
                "hi": "भगन्दर"
              },
              "Rheunatoid_Arthrites": {
                "value": "Rheunatoid_Arthrites",
                "en": "Rheumatoid Arthritis",
                "hi": "अनावता"
              },
              "Arenors": {
                "value": "Arenors",
                "en": "Arenors",
                "hi": "कंपवता"
              },
              "Sprain": {
                "value": "Sprain",
                "en": "Sprain",
                "hi": "वताकान्ताका"
              },
              "Diarrhoea": {
                "value": "Diarrhoea",
                "en": "Diarrhoea",
                "hi": "दस्त"
              },
              "Piles": {
                "value": "Piles",
                "en": "Piles",
                "hi": "आर्ष"
              },
              "Vomiting": {
                "value": "Vomiting",
                "en": "Vomiting",
                "hi": "चारदी"
              },
              "Epilepsy": {
                "value": "Epilepsy",
                "en": "Epilepsy",
                "hi": "अपस्मार"
              },
              "Cough": {
                "value": "Cough",
                "en": "Cough",
                "hi": "हिक्का"
              },
              "Mal_Absosption": {
                "value": "Mal_Absosption",
                "en": "Mal Absorption",
                "hi": "गृहणी"
              },
              "Hoarse_Voice": {
                "value": "Hoarse_Voice",
                "en": "Hoarse Voice",
                "hi": "कर्कश आवाज"
              },
              "Stiffness_of_Neck": {
                "value": "Stiffness_of_Neck",
                "en": "Stiffness of Neck",
                "hi": "मान्य स्तभा"
              },
              "Cardiac_Disorder": {
                "value": "Cardiac_Disorder",
                "en": "Cardiac Disorder",
                "hi": "हृदय रोग"
              },
              "Stomach_Pain": {
                "value": "Stomach_Pain",
                "en": "Stomach Pain",
                "hi": "उदर/आमाशय/ शोल्ला"
              },
              "Colic_Pain": {
                "value": "Colic_Pain",
                "en": "Colic Pain",
                "hi": "पेट का दर्द"
              },
              "Headache": {
                "value": "Headache",
                "en": "Headache",
                "hi": "सरदर्द"
              },
              "Hiccough": {
                "value": "Hiccough",
                "en": "Hiccough",
                "hi": "हिक्का"
              },
              "Excessive_Urination": {
                "value": "Excessive_Urination",
                "en": "Excessive Urination",
                "hi": "प्रमेहा"
              }
            }
          }
        }
      }
    },
    "diseaseslistResponse":{
      "type":"object",
      "description":"get the diseaseslistResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "value": "",
                "defaultlabel": "reason_for_visit"
              },
              {
                "value": "Abdominal_Pain",
                "en": "Abdominal Pain",
                "hi": "पेट में दर्द"
              },
              {
                "value": "Absence_Of_Periods",
                "en": "Absence Of Periods",
                "hi": "पीरियड्स की अनुपस्थिति"
              },
              {
                "value": "Acid_Reflux",
                "en": "Acid Reflux",
                "hi": "अम्ल प्रतिवाह"
              },
              {
                "value": "Acidity_Heart_Burn",
                "en": "Acidity, Heart Burn",
                "hi": "एसिडिटी, हार्ट बर्न"
              },
              {
                "value": "Alcohol_Abuse",
                "en": "Alcohol Abuse",
                "hi": "शराब का सेवन"
              },
              {
                "value": "Animal_Bite",
                "en": "Animal Bite",
                "hi": "पशु काटो"
              },
              {
                "value": "Asthama_Attack",
                "en": "Asthama Attack",
                "hi": "दमे का दौरा"
              },
              {
                "value": "Auxiety",
                "en": "Auxiety",
                "hi": "औचित्य"
              },
              {
                "value": "Back_Pain",
                "en": "Back Pain",
                "hi": "पीठ दर्द"
              },
              {
                "value": "Bed_Wetting",
                "en": "Bed Wetting",
                "hi": "बिस्तर गीला करना"
              },
              {
                "value": "Blackout",
                "en": "Blackout",
                "hi": "ब्लैकआउट"
              },
              {
                "value": "Blood_In_Sputum",
                "en": "Blood In Sputum",
                "hi": "स्पुतम में रक्त"
              },
              {
                "value": "Blurred_Vision",
                "en": "Blurred Vision",
                "hi": "धुंधली दृष्टि"
              },
              {
                "value": "Body_Stiffness",
                "en": "Body Stiffness",
                "hi": "शरीर की अकड़न"
              },
              {
                "value": "Bodyache",
                "en": "Bodyache",
                "hi": "शरीर दर्द"
              },
              {
                "value": "Breathlessness",
                "en": "Breathlessness",
                "hi": "सांस फूलना"
              },
              {
                "value": "Burn",
                "en": "Burn",
                "hi": "जलाना"
              },
              {
                "value": "Burning_Hand_Feet",
                "en": "Burning Hand & Feet",
                "hi": "जलता हुआ हाथ और पैर"
              },
              {
                "value": "Cavity_In_Teeth",
                "en": "Cavity In Teeth",
                "hi": "दांत में गुहा"
              },
              {
                "value": "Chest_Pain",
                "en": "Chest Pain",
                "hi": "छाती में दर्द"
              },
              {
                "value": "Cold_Running_Nose",
                "en": "Cold, Running Nose",
                "hi": "कोल्ड, रनिंग नोज"
              },
              {
                "value": "Colic_Pain",
                "en": "Colic Pain",
                "hi": "पेट का दर्द"
              },
              {
                "value": "Coma",
                "en": "Coma",
                "hi": "प्रगाढ़ बेहोशी"
              },
              {
                "value": "Constipation",
                "en": "Constipation",
                "hi": "कब्ज़"
              },
              {
                "value": "Convulsions_Tremos",
                "en": "Convulsions/Tremos",
                "hi": "आक्षेप / Tremos"
              },
              {
                "value": "Cough",
                "en": "Cough",
                "hi": "खांसी"
              },
              {
                "value": "Cramps_In_Legs",
                "en": "Cramps In Legs",
                "hi": "पैरों में ऐंठन"
              },
              {
                "value": "Cuts",
                "en": "Cuts",
                "hi": "कटौती"
              },
              {
                "value": "Depression",
                "en": "Depression",
                "hi": "डिप्रेशन"
              },
              {
                "value": "Diaper_Rashes",
                "en": "Diaper Rashes",
                "hi": "डायपर चकत्ते"
              },
              {
                "value": "Diarrhoea",
                "en": "Diarrhoea",
                "hi": "दस्त"
              },
              {
                "value": "Difficulty_In_Hear",
                "en": "Difficulty In Hear",
                "hi": "सुनने में कठिनाई"
              },
              {
                "value": "Difficulty_In_Hearing",
                "en": "Difficulty In Hearing",
                "hi": "सुनने में कठिनाई"
              },
              {
                "value": "Difficulty_Walking",
                "en": "Difficulty Walking",
                "hi": "चलने में कठिनाई"
              },
              {
                "value": "Dizziness_Drowsiness",
                "en": "Dizziness/Drowsiness",
                "hi": "चक्कर आना / उनींदापन"
              },
              {
                "value": "Dry_Skin",
                "en": "Dry Skin",
                "hi": "रूखी त्वचा"
              },
              {
                "value": "Ear_Pain",
                "en": "Ear Pain",
                "hi": "कान का दर्द"
              },
              {
                "value": "Excessive_Thirst",
                "en": "Excessive Thirst",
                "hi": "अत्यधिक प्यास"
              },
              {
                "value": "Face_Swelling",
                "en": "Face Swelling",
                "hi": "चेहरे पर सूजन"
              },
              {
                "value": "Fainting",
                "en": "Fainting",
                "hi": "बेहोशी"
              },
              {
                "value": "Fatigue",
                "en": "Fatigue",
                "hi": "थकान"
              },
              {
                "value": "Fever",
                "en": "Fever",
                "hi": "बुखा"
              },
              {
                "value": "Flatulence_Bloating",
                "en": "Flatulence/Bloating",
                "hi": "पेट फूलना / फूल"
              },
              {
                "value": "Hair_Loss",
                "en": "Hair Loss",
                "hi": "बाल झड़ना"
              },
              {
                "value": "Headache",
                "en": "Headache",
                "hi": "सरदर्द"
              },
              {
                "value": "Heavy_Bleeding",
                "en": "Heavy Bleeding",
                "hi": "भारी रक्तस्राव"
              },
              {
                "value": "Hiccups",
                "en": "Hiccups",
                "hi": "हिचकी"
              },
              {
                "value": "High_Blood_Pressure",
                "en": "High Blood Pressure",
                "hi": "उच्च रक्तचाप"
              },
              {
                "value": "Hoarse_Voice",
                "en": "Hoarse Voice",
                "hi": "कर्कश आवाज"
              },
              {
                "value": "Hot_Flushes",
                "en": "Hot Flushes",
                "hi": "गर्मी लगना"
              },
              {
                "value": "Indigestion",
                "en": "Indigestion",
                "hi": "खट्टी डकार"
              },
              {
                "value": "Infertility",
                "en": "Infertility",
                "hi": "बांझपन"
              },
              {
                "value": "Insect_Bite",
                "en": "Insect Bite",
                "hi": "कीड़े का काटना"
              },
              {
                "value": "Insomnia",
                "en": "Insomnia",
                "hi": "अनिद्रा"
              },
              {
                "value": "Intolerance_For_Light",
                "en": "Intolerance For Light",
                "hi": "लाइट के लिए असहिष्णुता"
              },
              {
                "value": "Irritability",
                "en": "Irritability",
                "hi": "चिड़चिड़ापन"
              },
              {
                "value": "Joint_Pain",
                "en": "Joint Pain",
                "hi": "जोड़ों का दर्द"
              },
              {
                "value": "Lack_Of_Conversation",
                "en": "Lack Of Conversation",
                "hi": "बातचीत का अभाव"
              },
              {
                "value": "Loss_Of_Appetite",
                "en": "Loss Of Appetite",
                "hi": "भूख में कमी"
              },
              {
                "value": "Loss_Of_Smell",
                "en": "Loss Of Smell",
                "hi": "गंध का नुकसान"
              },
              {
                "value": "Lump_In_Breast",
                "en": "Lump In Breast",
                "hi": "स्तन में गांठ"
              },
              {
                "value": "Menopause",
                "en": "Menopause",
                "hi": "रजोनिवृत्ति"
              },
              {
                "value": "Mental_Confusion",
                "en": "Mental Confusion",
                "hi": "मानसिक भ्रम की स्थिति"
              },
              {
                "value": "Mood_Swings",
                "en": "Mood Swings",
                "hi": "मूड के झूलों"
              },
              {
                "value": "Mouth_Odour",
                "en": "Mouth Odour",
                "hi": "मुँह गंध"
              },
              {
                "value": "Mouth_Ulcer",
                "en": "Mouth Ulcer",
                "hi": "मुँह में छाला"
              },
              {
                "value": "Muscle_Pain",
                "en": "Muscle Pain",
                "hi": "मांसपेशियों में दर्द"
              },
              {
                "value": "Nausea_Vomiting",
                "en": "Nausea/Vomitin",
                "hi": "मतली उल्टी"
              },
              {
                "value": "Neck_Rigidity",
                "en": "Neck Rigidity",
                "hi": "गर्दन की कठोरता"
              },
              {
                "value": "Nosebleed",
                "en": "Nosebleed",
                "hi": "नकसीर"
              },
              {
                "value": "Numbness",
                "en": "Numbness",
                "hi": "सुन्न होना"
              },
              {
                "value": "Over_Sweating",
                "en": "Over Sweating",
                "hi": "अधिक पसीना आना"
              },
              {
                "value": "Pain_During_Periods",
                "en": "Pain During Periods",
                "hi": "पीरियड्स के दौरान दर्द होना"
              },
              {
                "value": "Pain_In_Urination",
                "en": "Pain In Urination",
                "hi": "पेशाब में दर्द"
              },
              {
                "value": "Palpitation",
                "en": "Palpitation",
                "hi": "घबराहट"
              },
              {
                "value": "Panic_Attack",
                "en": "Panic Attack",
                "hi": "आतंकी हमले"
              },
              {
                "value": "Pregnancy",
                "en": "Pregnancy",
                "hi": "गर्भावस्था"
              },
              {
                "value": "Redness_In_Eyes",
                "en": "Redness In Eyes",
                "hi": "आँखों में लालिमा"
              },
              {
                "value": "Reduce_Sex_Drive",
                "en": "Reduce Sex Drive",
                "hi": "सेक्स ड्राइव को कम करें"
              },
              {
                "value": "Restlessness",
                "en": "Restlessness",
                "hi": "बेचैनी"
              },
              {
                "value": "Scanty_Bleeding",
                "en": "Scanty Bleeding",
                "hi": "स्कैंटी ब्लीडिंग"
              },
              {
                "value": "Seizure",
                "en": "Seizure",
                "hi": "दौरा"
              },
              {
                "value": "Skin_Lesion",
                "en": "Skin Lesion",
                "hi": "त्वचा पर घाव"
              },
              {
                "value": "Skin_Rashes",
                "en": "Skin Rashes",
                "hi": "त्वचा के चकत्ते"
              },
              {
                "value": "Slurred_Speech",
                "en": "Slurred Speech",
                "hi": "तिरस्कारपूर्ण भाषण"
              },
              {
                "value": "Small_Dots_On_Skin",
                "en": "Small Dots On Skin",
                "hi": "त्वचा पर छोटे डॉट्स"
              },
              {
                "value": "Snoring",
                "en": "Snoring",
                "hi": "खर्राटे"
              },
              {
                "value": "Sores",
                "en": "Sores",
                "hi": "घावों"
              },
              {
                "value": "Suicidal_Ideation",
                "en": "Suicidal Ideation",
                "hi": "जान लेवा विचार"
              },
              {
                "value": "Swelling_In_Body",
                "en": "Swelling In Body",
                "hi": "शरीर में सूजन"
              },
              {
                "value": "Swelling_In_Eyes",
                "en": "Swelling In Eyes",
                "hi": "आँखों में सूजन"
              },
              {
                "value": "Throat_Pain",
                "en": "Throat Pain",
                "hi": "गले का दर्द"
              },
              {
                "value": "Tingling",
                "en": "Tingling",
                "hi": "झुनझुनी"
              },
              {
                "value": "Trembling",
                "en": "Trembling",
                "hi": "झुनझुनी"
              },
              {
                "value": "Twitchingin_Limbs",
                "en": "Twitchingin Limbs",
                "hi": "अंग-अंग में चिकोटी"
              },
              {
                "value": "Vaginal_Discharge",
                "en": "Vaginal Discharge",
                "hi": "योनि स्राव"
              },
              {
                "value": "Vaginal_Itching",
                "en": "Vaginal Itching",
                "hi": "योनि में खुजली"
              },
              {
                "value": "Weak_Memory",
                "en": "Weak Memory",
                "hi": "कमजोर याददाश्त"
              },
              {
                "value": "Weakness",
                "en": "Weakness",
                "hi": "दुर्बलता"
              },
              {
                "value": "Weight_Gain",
                "en": "Weight Gain",
                "hi": "भार बढ़ना"
              },
              {
                "value": "Weight_Loss",
                "en": "Weight Loss",
                "hi": "वजन घटना"
              }
            ]
          }
        }
      }
    },
    "qualificationlistResponse":{
      "type":"object",
      "description":"get the qualificationlistResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "value": "",
                "defaultlabel": "select_degree",
                "en": "Select Qualification"
              },
              {
                "value": "MD",
                "en": "MD(Ay)"
              },
              {
                "value": "MS(Ay)",
                "en": "MS(Ay)"
              },
              {
                "value": "MBBS",
                "en": "MBBS"
              },
              {
                "value": "DNB",
                "en": "DNB"
              },
              {
                "value": "MEM",
                "en": "MEM"
              },
              {
                "value": "MCH",
                "en": "MCH"
              },
              {
                "value": "DGO",
                "en": "DGO"
              },
              {
                "value": "Diploma_in_Cardiology",
                "en": "Diploma in Cardiology"
              }
            ]
          }
        }
      }
    },
    "specializationlistResponse":{
      "type":"object",
      "description":"get the specializationlistResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": {
              "ayurvedic": [
                {
                  "value": "Allergist",
                  "en": "Allergist",
                  "hi": "एलर्जी"
                },
                {
                  "value": "Dermatologist",
                  "en": "Dermatologist",
                  "hi": "त्वचा विशेषज्ञ"
                },
                {
                  "value": "ENT_specialist",
                  "en": "ENT Specialist",
                  "hi": "ईएनटी विशेषज्ञ"
                },
                {
                  "value": "General_Physician",
                  "en": "General Physician",
                  "hi": "सामान्य चिकित्सक"
                },
                {
                  "value": "Gynecologist_&_Obstetrician",
                  "en": "Gynecologist&Obstetrician",
                  "hi": "स्त्री रोग विशेषज्ञ और प्रसूति रोग विशेषज्ञ"
                },
                {
                  "value": "Panch_Karma",
                  "en": "Panch Karma",
                  "hi": "पञ्च कर्मा"
                },
                {
                  "value": "Surgeon",
                  "en": "Surgeon",
                  "hi": "शल्य/क्षार सूत्र विशेषज्ञ"
                }
              ],
              "homeopathy": [
                {
                  "value": "homeopathy_medicine",
                  "en": "Homeopathy Medicine",
                  "hi": "होम्योपैथी चिकित्सा"
                }
              ],
              "unani": [
                {
                  "value": "unani_medicine",
                  "en": "Unani Medicine",
                  "hi": "यूनानी चिकित्सा"
                }
              ],
              "allopathy": [
                {
                  "value": "Anesthesiologist",
                  "en": "Anesthesiologist",
                  "hi": "निश्चेतना विशेषज्ञ"
                },
                {
                  "value": "Cardiologist",
                  "en": "Cardiologist",
                  "hi": "हृदय रोग विशेषज्ञ"
                },
                {
                  "value": "Cardiac_surgeon",
                  "en": "Cardiac Surgeon",
                  "hi": "हृदय शल्य चिकित्सक"
                },
                {
                  "value": "Child_Specialist",
                  "en": "Child Specialist",
                  "hi": "बाल विशेषज्ञ"
                },
                {
                  "value": "Critical_Care_specialist",
                  "en": "Critical Care specialist",
                  "hi": "क्रिटिकल केयर स्पेशलिस्ट"
                },
                {
                  "value": "Endocrinologist",
                  "en": "Endocrinologist",
                  "hi": "एंडोक्राइनोलॉजिस्ट"
                },
                {
                  "value": "Gastroenterologist",
                  "en": "Gastroenterologist",
                  "hi": "जठरांत्र चिकित्सक"
                },
                {
                  "value": "General_surgeon",
                  "en": "General Surgeon",
                  "hi": "सार्विक शल्य चिकित्सक"
                },
                {
                  "value": "Internal_medicine",
                  "en": "Internal Medicine",
                  "hi": "आंतरिक चिकित्सा"
                },
                {
                  "value": "Nephrologist",
                  "en": "Nephrologist",
                  "hi": "किडनी रोग विशेषज्ञ"
                },
                {
                  "value": "Neurologist",
                  "en": "Neurologist",
                  "hi": "न्यूरोलॉजिस्ट"
                },
                {
                  "value": "Obstetrician_gynecologist",
                  "en": "Obstetrician/gynecologist",
                  "hi": "दाई स्त्रीरोग विशेषज्ञ"
                },
                {
                  "value": "Oncologist",
                  "en": "Oncologist",
                  "hi": "ऑन्कोलॉजिस्ट"
                },
                {
                  "value": "Ophthalmologist",
                  "en": "Ophthalmologist",
                  "hi": "नेत्र-विशेषज्ञ"
                },
                {
                  "value": "Orthopedic_surgeon",
                  "en": "Orthopedic Surgeon",
                  "hi": "हड्डियो का सर्जन"
                },
                {
                  "value": "Psychiatrist",
                  "en": "Psychiatrist",
                  "hi": "मनोचिकित्सक"
                },
                {
                  "value": "Pulmonologist",
                  "en": "Pulmonologist",
                  "hi": "फुफ्फुसीय रोग विशेषज्ञ"
                },
                {
                  "value": "Radiologist",
                  "en": "Radiologist",
                  "hi": "रेडियोलोकेशन करनेवाला"
                },
                {
                  "value": "Rheumatologist",
                  "en": "Rheumatologist",
                  "hi": "ह्रुमेटोलॉजिस्ट"
                },
                {
                  "value": "Urologist",
                  "en": "Urologist",
                  "hi": "उरोलोजिस्त"
                }
              ]
            }
          }
        }
      }
    },
    "departmentlistResponse":{
      "type":"object",
      "description":"get the departmentlistResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "value": "",
                "defaultlabel": "select_department",
                "en": "Select Department",
                "hi": "विभाग चुनें"
              },
              {
                "value": "ayurvedic",
                "en": "Ayurvedic",
                "hi": "आयुर्वेदिक"
              },
              {
                "value": "homeopathy",
                "en": "Homeopathy",
                "hi": "होम्योपैथी"
              },
              {
                "value": "unani",
                "en": "Unani",
                "hi": "यूनानी चिकित्सा"
              },
              {
                "value": "allopathy",
                "en": "Allopathy",
                "hi": "एलोपैथी"
              }
            ]
          }
        }
      }
    },
    "frequsersResponse":{
      "type":"object",
      "description":"get the frequsersResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "_id": "637c7bee915b80a9481bcceb",
                "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
                "consultRole": "user",
                "email": "abyssuser@yopmail.com",
                "phone": "",
                "createdAt": 1669102574096,
                "updatedDate": 1669102574096,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "abyssuser",
                "title": "",
                "consultantTypes": [],
                "consultId": "U25576",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true,
                "__v": 0
              }
            ],
            "correspondingCounts": {
              "57bb5100-6a38-11ed-b813-2501004b39ce": 79
            }
          }
        }
      }
    },
    "freqconsultantsResponse":{
      "type":"object",
      "description":"get the freqconsultantsResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "_id": "637c69e30035d90008e946ca",
                "consultantTypes": [
                  "Legal_Consultant"
                ],
                "businessProfiles": [
                  {
                    "businessName": "",
                    "consultantType": "Legal_Consultant",
                    "designation": "",
                    "consultantSubType": "Intellectual_Property_Lawyer"
                  }
                ],
                "languages": [],
                "emailVerified": true,
                "userId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
                "createdAt": 1669097955867,
                "updatedDate": 1669097955867,
                "consultRole": "consultant",
                "search_term": "",
                "consultId": "CO67033",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "abysscon",
                "email": "abysscon@yopmail.com",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "currency": "INR",
                "__v": 0
              }
            ],
            "correspondingCounts": {
              "96ee36e0-6a2d-11ed-815e-39dc30574417": 79
            }
          }
        }
      }
    },
    "consultantdataResponse":{
      "type":"object",
      "description":"get the consultantdataResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "img": "./images/icons/management-consultant.png",
                "name": "Legal Consultant",
                "numOfConsults": "3 Consultants",
                "value": "Legal_Consultant",
                "name_hindi": "विधिक परामर्शक"
              },
              {
                "img": "./images/icons/operations-consultant.png",
                "name": "Health And Wellness Consultant",
                "numOfConsults": "20 Consultants",
                "value": "Health_And_Wellness_Consultant",
                "name_hindi": "स्वास्थ्य और कल्याण सलाहकार"
              },
              {
                "img": "./images/icons/stratergy-consultant.png",
                "name": "Human Resource Consultant",
                "numOfConsults": "4 Consultants",
                "value": "HumanResource_Consultant",
                "name_hindi": "मानव संसाधन सलाहकार"
              },
              {
                "img": "./images/icons/hr-consultant.png",
                "name": "Education Consultant",
                "numOfConsults": "8 Consultants",
                "value": "Education_Consultant",
                "name_hindi": "शिक्षा सलाहकार"
              },
              {
                "img": "./images/icons/marketing-consultant.png",
                "name": "Miscellaneous Consultant",
                "numOfConsults": "18 Consultant",
                "value": "Miscellaneous_Consultant",
                "name_hindi": "विविध सलाहकार"
              }
            ]
          }
        }
      }
    },
    "consultantcountResponse":{
      "type":"object",
      "description":"get the consultantdataResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "type": "Legal_Consultant",
                "count": 6
              },
              {
                "type": "Health_And_Wellness_Consultant",
                "count": 2
              },
              {
                "type": "HumanResource_Consultant",
                "count": 0
              },
              {
                "type": "Education_Consultant",
                "count": 1
              },
              {
                "type": "Miscellaneous_Consultant",
                "count": 0
              }
            ]
          }
        }
      }
    },
    "subdomainsResponse":{
      "type":"object",
      "description":"get the consultantdataResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "_id": "636be690eb30d3afaa0df287",
                "corporateId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "subdomain": "pavan",
                "name": "pavan",
                "createdAt": 1668015760456,
                "updatedAt": "2022-11-22T07:34:46.800Z",
                "__v": 0,
                "logo": "https://insta-consult.s3-ap-southeast-1.amazonaws.com/consult-logos/consult-logos/1669102482575.jpg"
              },
              {
                "_id": "636be874eb30d3afaa0df296",
                "corporateId": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "subdomain": "testapp",
                "name": "Clinic",
                "createdAt": 1668016244121,
                "updatedAt": "2022-11-09T17:50:44.121Z",
                "__v": 0
              },
              {
                "_id": "637223f914b6c6000852eb33",
                "corporateId": "09cbbbe0-640e-11ed-9304-f79ae861ecea",
                "subdomain": "net",
                "name": "internet ",
                "createdAt": 1668424697559,
                "updatedAt": "2022-11-14T11:18:17.559Z",
                "__v": 0
              },
              {
                "_id": "6374a593214bdf0008fff3da",
                "corporateId": "76881510-658c-11ed-8c29-4f7ef94c6cff",
                "subdomain": "inccorp",
                "name": "IncCorp",
                "createdAt": 1668588947732,
                "updatedAt": "2022-11-16T08:55:47.732Z",
                "__v": 0
              },
              {
                "_id": "637c62829df423e0b13bf318",
                "corporateId": "30ac1220-6a29-11ed-8a06-7f5362220ab3",
                "subdomain": "sandeep",
                "name": "Sandeep multi-speciality ",
                "createdAt": 1669096066180,
                "updatedAt": "2022-11-22T05:47:46.180Z",
                "__v": 0
              },
              {
                "_id": "637ccc8bd73d4651bc0ca080",
                "corporateId": "645a83b0-6a68-11ed-995b-e1dc0985fe51",
                "subdomain": "sandeepA",
                "name": "Sandeep multi-speciality ",
                "createdAt": 1669123211160,
                "updatedAt": "2022-11-22T13:20:11.160Z",
                "__v": 0
              }
            ]
          }
        }
      }
    },
    "createCustomerCare":{
      "type": "object",
      "properties": {
        "userId": {
          "type": "string",
          "description": "userId of the user"
        },
        "subdomain": {
          "type": "string",
          "description": "subdomain of the user"
        }
      },
      "description": "about creation createDomainconfirmation",
      "example": {
        "userId":"57bb5100-6a38-11ed-b813-2501004b39ce",
        "subdomain":"pavan"
      }
    },
    "createCustomerCareResponse":{
      "type":"object",
      "description":"get the createCustomerCareResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": {
              "_id": "637e51964366adee0a8fda75",
              "subdomain": "pavan",
              "days": [],
              "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
              "createdAt": "2022-11-23T17:00:06.427Z",
              "updatedAt": "2022-11-23T17:00:06.427Z",
              "__v": 0
            }
          }
        }
      }
    },
    "createmailtocare":{
      "type": "object",
      "properties": {
        "userId": {
          "type": "string",
          "description": "userId of the user"
        },
        "subdomain": {
          "type": "string",
          "description": "subdomain of the user"
        }
      },
      "description": "about creation createmailtocare",
      "example": {
        "userId":"1",
        "subdomain":"2"
      }
    },
    "createmailtocareResponse":{
      "type":"object",
      "description":"get the createmailtocareResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "licenseurldetailsResponse":{
      "type":"object",
      "description":"get the licenseurldetailsResponse",
      "example":{
        "response":{
          "data":"pdf"
        }
      }
    },
    "createlicensedetails":{
      "type": "object",
      "properties": {
        "userId": {
          "type": "string",
          "description": "userId of the user"
        },
        "licenseName": {
          "type": "string",
          "description": "licenseName of the license"
        }
      },
      "description": "about creation createmailtocare",
      "example": {
        "userId":"e84e36c0-6055-11ed-a97e-337e329b11a8",
        "licenseName":"INVCFREE"
      }
    },
    "createlicensedetailsResponse":{
      "type":"object",
      "description":"get the createlicensedetailsResponse",
      "example":{
        "response":{
          "data":{
            "status": true,
            "result": {
              "purchasedOn": 1668015760639,
              "expiresOn": 1669225360639,
              "noOfLicenses": 5,
              "userId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
              "consultRole": "corporate"
            }
          }
        }
      }
    },
    "usercorpsResponse":{
      "type":"object",
      "description":"get the usercorpsResponse",
      "example":{
        "response":{
          "data":"corporateList || No data found"
        }
      }
    },
    "getcorporatepaymentResponse":{
      "type":"object",
      "description":"get the usercorpsResponse",
      "example":{
        "response":{
          "status": true,
          "data": {
            "_id": "636be690eb30d3afaa0df28a",
            "consultantTypes": [
              "Health_And_Wellness_Consultant"
            ],
            "businessProfiles": [
              {
                "address": "Hyderabad ",
                "businessEmail": "sandeep@yopmail.com",
                "businessName": "Sandeep multi-speciality ",
                "city": "",
                "consultantSubType": "Paediatrician",
                "consultantType": "Health_And_Wellness_Consultant",
                "country": "Djibouti",
                "designation": "Associate_Paediatrician",
                "licenseNumber": "9248",
                "pincode": "508001",
                "state": "Dikhil",
                "yearsExperience": "5"
              }
            ],
            "languages": [],
            "emailVerified": true,
            "userId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
            "createdAt": 1668015760544,
            "updatedDate": 1669107865408,
            "consultRole": "corporate",
            "search_term": " sandep@yopmail.com",
            "corporateName": "Pavan K",
            "contactName": "Pavan K",
            "consultId": "C86801",
            "consultantsCount": 5,
            "gender": "Male",
            "firstName": "sandeep ",
            "expiryAt": 1669225360544,
            "email": "sandep@yopmail.com",
            "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
            "subdomain": "pavan",
            "timeZone": "Asia/Calcutta",
            "currency": "INR",
            "updatedAt": "2022-11-22T09:04:25.409Z",
            "__v": 0,
            "confirmed": true,
            "mToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJlODRlMzZjMC02MDU1LTExZWQtYTk3ZS0zMzdlMzI5YjExYTgiLCJzdWJkb21haW4iOiJwYXZhbiIsImVtYWlsIjoidGVzdHVzZXJAeW9wbWFpbC5jb20iLCJjb25zdWx0Um9sZSI6ImNvcnBvcmF0ZSIsInNlc3Npb25JZCI6IjU0N2NmNDEwLTZhMjYtMTFlZC1hYjc5LWY3NTc2NTI4ODYwYiIsImlhdCI6MTY2OTA5NDgzNywiZXhwIjoxNjY5MTgxMjM3fQ.uDFuc8OWg8ucOnRUpVy_TnGKBBR0xQ84sPUzPWCLf7g",
            "defaultRoom": "637c76b6edd7d7742e530d40",
            "mcuServer": "https://awsmcu-20.instavc.com/",
            "address": "Hyderabad ",
            "city": "Jinjiang",
            "consultationFee": "12000",
            "country": "China",
            "countryCode": "91",
            "designation": null,
            "lastName": "kumar ",
            "phone": "9018466464",
            "pincode": "508000",
            "state": "Fujian",
            "taxes": 12,
            "title": "Mr."
          }
        }
      }
    },
    "getpaidandunpaidsubdomainsResponse":{
      "type":"object",
      "description":"get the usercorpsResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": [
              {
                "_id": "636be690eb30d3afaa0df287",
                "corporateId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "subdomain": "pavan",
                "name": "pavan",
                "createdAt": 1668015760456,
                "updatedAt": "2022-11-22T07:34:46.800Z",
                "__v": 0,
                "logo": "https://insta-consult.s3-ap-southeast-1.amazonaws.com/consult-logos/consult-logos/1669102482575.jpg"
              },
              {
                "_id": "636be690eb30d3afaa0df287",
                "corporateId": "e84e36c0-6055-11ed-a97e-337e329b11a8",
                "subdomain": "pavan",
                "name": "pavan",
                "createdAt": 1668015760456,
                "updatedAt": "2022-11-22T07:34:46.800Z",
                "__v": 0,
                "logo": "https://insta-consult.s3-ap-southeast-1.amazonaws.com/consult-logos/consult-logos/1669102482575.jpg"
              },
              {
                "_id": "636be874eb30d3afaa0df296",
                "corporateId": "1c051b4a-5b96-405e-acca-5d74855caba4",
                "subdomain": "testapp",
                "name": "Clinic",
                "createdAt": 1668016244121,
                "updatedAt": "2022-11-09T17:50:44.121Z",
                "__v": 0
              }
            ]
          }
        }
      }
    },
    "createlicense":{
      "type": "object",
      "properties": {
        "userId": {
          "type": "string",
          "description": "userId of the user"
        },
        "licenseName": {
          "type": "string",
          "description": "licenseName of the license"
        },
        "licenseCount": {
          "type": "string",
          "description": "licenseName of the license"
        },
        "paidAmount": {
          "type": "string",
          "description": "paidAmount of the license"
        }

      },
      "description": "about creation createmailtocare",
      "example": {
        "userId":"1",
        "licenseName":"2",
        "licenseCount":"3",
        "paidAmount":"4"
      }
    },
    "createlicenseResponse":{
      "type":"object",
      "description":"get the createlicenseResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createorder":{
      "type": "object",
      "properties": {
        "productCode": {
          "type": "string",
          "description": "productCode of the order"
        },
        "userId": {
          "type": "string",
          "description": "userId of the user"
        },
        "qty": {
          "type": "string",
          "description": "qty of the order"
        },
        "couponCode": {
          "type": "string",
          "description": "couponCode of the order"
        },
        "subdomain": {
          "type": "string",
          "description": "subdomain"
        },
        "phone": {
          "type": "string",
          "description": "phone number"
        },
        "username": {
          "type": "string",
          "description": "username of user"
        }

      },
      "description": "about creation createmailtocare",
      "example": {
        "productCode":"1",
        "userId":"2",
        "qty":"3",
        "couponCode":"4",
        "subdomain":"5",
        "phone":"6",
        "username":"7"
      }
    },
    "createorderResponse":{
      "type":"object",
      "description":"get the createorderResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "capturepayment":{
      "type": "object",
      "properties": {
        "paymentId": {
          "type": "string",
          "description": "paymentId of the order"
        },
        "amount": {
          "type": "string",
          "description": "amount of the order"
        },
        "currency": {
          "type": "string",
          "description": "currency of the amount"
        }
      },
      "description": "about creation capturepayment",
      "example": {
        "paymentId":"1",
        "amount":"2",
        "currency":"3"
      }
    },
    "capturepaymentResponse":{
      "type":"object",
      "description":"get the capturepaymentResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "paymentResponse":{
      "type":"object",
      "description":"get the capturepaymentResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createcoupon":{
      "type": "object",
      "properties": {
        "productCode": {
          "type": "string",
          "description": "productCode of the order"
        },
        "couponCode": {
          "type": "string",
          "description": "couponCode of the order"
        },
        "discount": {
          "type": "string",
          "description": "discount"
        },
        "expireAt": {
          "type": "string",
          "description": "expireAt date"
        }

      },
      "description": "about creation createcoupon",
      "example": {
        "productCode":"1",
        "couponCode":"4",
        "discount":"5",
        "expireAt":"6"
      }
    },
    "createcouponResponse":{
      "type":"object",
      "description":"get the createcouponResponse",
      "example":{
        "response":{
          "data":"response"
        }
      }
    },
    "doctorslotsResponse":{
      "type":"object",
      "description":"get the doctorslotsResponse",
      "example":{
        "response":{
          "data":"data || []"
        }
      }
    },
    "doctorschedulesResponse":{
      "type":"object",
      "description":"get the doctorschedulesResponse",
      "example":{
        "response":{
            "status": true,
            "data": [],
            "disableDates": {}
        }
      }
    },
    "createappointment":{
      "type": "object",
      "properties": {
        "startTime": {
          "type": "number",
          "description": "statTime of the creation"
        },
        "endTime": {
          "type": "number",
          "description": "endTime of the creation"
        },
        "scheduleId": {
          "type": "string",
          "description": "id  of the schedule"
        },
        "slotId": {
          "type": "string",
          "description": "id of the slot"
        },
        "consultantId": {
          "type": "string",
          "description": "id of the consultant"
        },
        "consultantType": {
          "type": "string",
          "description": "type of the consultant"
        },
        "userId": {
          "type": "string",
          "description": "id of the user"
        },
        "reason": {
          "type": "string",
          "description": "reason"
        },
        "day": {
          "type": "number",
          "description": "expireAt date"
        },
        "corporateId": {
          "type": "string",
          "description": "id of the corportate"
        },
        "adminId": {
          "type": "string",
          "description": "id of the admin"
        }

      },
      "description": "about creation createcoupon",
      "example": {
        "startTime":"1",
        "endTime":"4",
        "scheduleId":"5",
        "slotId":"6",
        "consultantId":"3",
        "consultantType":"7",
        "userId":"8",
        "reason":"9",
        "day":"0",
        "corporateId":"3",
        "adminId":"4"
      }
    },
    "createappointmentResponse":{
      "type":"object",
      "description":"get the createappointmentResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getappointmentResponse":{
      "type":"object",
      "description":"get the getappointmentResponse",
      "example":{
        "response":{
          
            "status": true,
            "data": [
              {
                "_id": "637cac7b0427966f1aba6b79",
                "appointmentId": "477b22d0-6a55-11ed-a1a9-4d790ca90700",
                "consultantId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
                "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
                "corporateId": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "startTime": 1669106340000,
                "endTime": 1669107240000,
                "scheduleId": "f7ae1541-6a37-11ed-8638-a122bc0d08ff",
                "slotId": "8ffd9270-6a3e-11ed-a153-0553ba9b2089",
                "reason": "test",
                "description": "",
                "appt_status": "pending",
                "userData": {
                  "name": "abyssuser",
                  "gender": "",
                  "phone": "",
                  "subdomain": "testapp",
                  "email": "abyssuser@yopmail.com",
                  "consultId": "U25576"
                },
                "consultantData": {
                  "name": "abysscon",
                  "email": "abysscon@yopmail.com",
                  "consultantType": "Legal_Consultant",
                  "currency": "INR",
                  "subdomain": "testapp",
                  "title": "Mr./Mrs."
                },
                "createdBy": "96ee36e0-6a2d-11ed-815e-39dc30574417",
                "uploads": [],
                "appt_day": 2,
                "createdAt": 1669115003147,
                "paymentStatus": "initiated",
                "consultationType": "Legal_Consultant",
                "paymentIntentId": "",
                "updatedAt": "2022-11-22T11:03:23.147Z",
                "__v": 0
              }
            ]
          
        }
      }
    },
    "updateAppointment":{
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "id of the appointment"
        },
        "status": {
          "type": "string",
          "description": "status of the appointment"
        }

      },
      "description": "about creation createcoupon",
      "example": {
        "id":"1",
        "status":"4"
      }
    },
    "consultantappointmentResponse":{
      "type":"object",
      "description":"get the consultantappointmentResponse",
      "example":{
        "response":{
          
"appointmentId":"477b22d0-6a55-11ed-a1a9-4d790ca90700",
"consultantId":"96ee36e0-6a2d-11ed-815e-39dc30574417",
 "userId":"57bb5100-6a38-11ed-b813-2501004b39ce",
"corporateId":"0da9ac80-455e-4d2f-9424-77b18638293f",
"startTime":"1669106340000",
"endTime":"1669107240000",
"scheduleId":"f7ae1541-6a37-11ed-8638-a122bc0d08ff",
"slotId":"8ffd9270-6a3e-11ed-a153-0553ba9b2089",
"reason":"test",
"description":"asdfssd",
"appt_status":"pending",
"userData": {},
"consultantData":{},
"createdBy":"96ee36e0-6a2d-11ed-815e-39dc30574417",
"uploads":[],
"appt_day":2,
"createdAt":1669115003147,
"paymentStatus":"initiated",
"consultationType":"Legal_Consultant",
"paymentIntentId":"",
"updatedAt":"2022-11-22T11:03:23.147+00:00"
        }
      }
    },
    "getappointmentIdResponse":{
      "type":"object",
      "description":"get the getappointmentIdResponse",
      "example":{
        "response":{
          "data":{
            "status": true,
            "data": {
              "_id": "637ccdfa476f4228382976f0",
              "appointmentId": "3ee3cbe0-6a69-11ed-9160-13eb6ba70aea",
              "consultantId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
              "corporateId": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "startTime": 1669106340000,
              "endTime": 1669107240000,
              "scheduleId": "f7ae1541-6a37-11ed-8638-a122bc0d08ff",
              "slotId": "8ffd9270-6a3e-11ed-a153-0553ba9b2089",
              "reason": "test",
              "description": "",
              "appt_status": "pending",
              "userData": {
                "_id": "637c7bee915b80a9481bcceb",
                "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
                "consultRole": "user",
                "email": "abyssuser@yopmail.com",
                "phone": "",
                "createdAt": 1669102574096,
                "updatedDate": 1669102574096,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "abyssuser",
                "title": "",
                "consultantTypes": [],
                "consultId": "U25576",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-22T07:37:27.415Z",
                "__v": 0
              },
              "consultantData": {
                "_id": "637c69e30035d90008e946ca",
                "consultantTypes": [
                  "Legal_Consultant"
                ],
                "businessProfiles": [
                  {
                    "businessName": "",
                    "consultantType": "Legal_Consultant",
                    "designation": "",
                    "consultantSubType": "Intellectual_Property_Lawyer"
                  }
                ],
                "languages": [],
                "emailVerified": true,
                "userId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
                "createdAt": 1669097955867,
                "updatedDate": 1669097955867,
                "consultRole": "consultant",
                "search_term": "",
                "consultId": "CO67033",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "abysscon",
                "email": "abysscon@yopmail.com",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "currency": "INR",
                "updatedAt": "2022-11-22T07:18:31.926Z",
                "__v": 0
              },
              "createdBy": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "uploads": [],
              "appt_day": 2,
              "createdAt": 1669123578351,
              "paymentStatus": "initiated",
              "consultationType": "Legal_Consultant",
              "paymentIntentId": "",
              "updatedAt": "2022-11-22T13:26:18.351Z",
              "__v": 0
            }
          }
        }
      }
    },
    "getConsultantResponse":{
      "type":"object",
      "description":"get the getConsultantResponse",
      "example":{
        "response":{
          "data": {
            "status": true,
            "data": {
              "_id": "637ccdfa476f4228382976f0",
              "appointmentId": "3ee3cbe0-6a69-11ed-9160-13eb6ba70aea",
              "consultantId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
              "corporateId": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "startTime": 1669106340000,
              "endTime": 1669107240000,
              "scheduleId": "f7ae1541-6a37-11ed-8638-a122bc0d08ff",
              "slotId": "8ffd9270-6a3e-11ed-a153-0553ba9b2089",
              "reason": "test",
              "description": "",
              "appt_status": "pending",
              "userData": {
                "_id": "637c7bee915b80a9481bcceb",
                "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
                "consultRole": "user",
                "email": "abyssuser@yopmail.com",
                "phone": "",
                "createdAt": 1669102574096,
                "updatedDate": 1669102574096,
                "gender": "",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "abyssuser",
                "title": "",
                "consultantTypes": [],
                "consultId": "U25576",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "businessProfiles": [
                  {}
                ],
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "languages": [],
                "emailVerified": true,
                "updatedAt": "2022-11-22T07:37:27.415Z",
                "__v": 0
              },
              "consultantData": {
                "_id": "637c69e30035d90008e946ca",
                "consultantTypes": [
                  "Legal_Consultant"
                ],
                "businessProfiles": [
                  {
                    "businessName": "",
                    "consultantType": "Legal_Consultant",
                    "designation": "",
                    "consultantSubType": "Intellectual_Property_Lawyer"
                  }
                ],
                "languages": [],
                "emailVerified": true,
                "userId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
                "createdAt": 1669097955867,
                "updatedDate": 1669097955867,
                "consultRole": "consultant",
                "search_term": "",
                "consultId": "CO67033",
                "assignedTo": "0da9ac80-455e-4d2f-9424-77b18638293f",
                "firstName": "abysscon",
                "email": "abysscon@yopmail.com",
                "password": "7f8c5f3fec96e1f95cf937fb16e2f787",
                "subdomain": "testapp",
                "timeZone": "Asia/Calcutta",
                "currency": "INR",
                "updatedAt": "2022-11-22T07:18:31.926Z",
                "__v": 0
              },
              "createdBy": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "uploads": [],
              "appt_day": 2,
              "createdAt": 1669123578351,
              "paymentStatus": "initiated",
              "consultationType": "Legal_Consultant",
              "paymentIntentId": "",
              "updatedAt": "2022-11-22T13:26:18.351Z",
              "__v": 0,
              "meetingId": "637dc3b201dfe359692a7873",
              "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6IjYyZjRjODRkNzgyMTM0MWVkNGVmM2JiYiIsImFwcEtleSI6InQ2dWZxMjlETW5HUjVKSyIsImlhdCI6MTY2MDIwOTMxNX0.ffILva50i5JzeMH0vwC8AcYjP4gmAyTGzQKoOsGQ5kk"
            }
          }
        }
      }
    },
    "getInvoiceDataResponse":{
      "type":"object",
      "description":"get the getInvoiceDataResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createChat":{
      "type": "object",
      "properties": {
        "apptId": {
          "type": "string",
          "description": "apptId of the chat"
        },
        "message": {
          "type": "string",
          "description": "text of the message"
        },
        "name": {
          "type": "string",
          "description": "name of the user"
        },
        "messageType": {
          "type": "string",
          "description": "type of the message"
        },
        "email": {
          "type": "string",
          "description": "email of the user"
        }
      },
      "description": "about creation createcoupon",
      "example": {
        "apptId":"1",
        "message":"4",
        "name":"5",
        "messageType":"6",
        "email":"3"
      }
    },
    "createChatResponse":{
      "type":"object",
      "description":"get the createChatResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getChatResponse":{
      "type":"object",
      "description":"get the getChatResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createPatientmedical":{
      "type": "object",
      "properties": {
        "uploadkey": {
          "type": "string",
          "description": "uploadkey of the patient"
        },
        "uploadtype": {
          "type": "string",
          "description": "uploadtype of the patient"
        },
        "uploadname": {
          "type": "string",
          "description": "uploadname of the uploadname"
        },
        "url": {
          "type": "string",
          "description": "url of the patient"
        },
        "size": {
          "type": "string",
          "description": "size of the patient"
        }
      },
      "description": "about creation createcoupon",
      "example": {
        "uploadkey":"1",
        "uploadtype":"4",
        "uploadname":"5",
        "url":"6",
        "size":"3"
      }
    },
    "createPatientmedicalResponse":{
      "type":"object",
      "description":"get the createPatientmedicalResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "patientMedicalResponse":{
      "type":"object",
      "description":"get the patientMedicalResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deletePatientMedical":{
      "type": "object",
      "properties": {
        "uploadkey": {
          "type": "string",
          "description": "uploadkey of the patient"
        }
      },
      "description": "about creation createcoupon",
      "example": {
        "uploadkey":"1"
      }
    },
    "deletePatientMedicalResponse":{
      "type":"object",
      "description":"get the deletePatientMedicalResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createdrugalergies":{
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "name of the drugalergies"
        },
        "description": {
          "type": "string",
          "description": "description of the drugalergies"
        }
      },
      "description": "about creation drugalergies",
      "example": {
        "name":"1",
        "description":"4"
      }
    },
    "createdrugalergiesResponse":{
      "type":"object",
      "description":"get the createdrugalergiesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getDrugalergiesResponse":{
      "type":"object",
      "description":"get the getDrugalergiesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "drugalergiesResponse":{
      "type":"object",
      "description":"get the drugalergiesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteDrugAllergiesResponse":{
      "type":"object",
      "description":"get the deleteDrugAllergiesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "updatedrugalergies":{
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "name of the drugalergies"
        },
        "description": {
          "type": "string",
          "description": "description of the drugalergies"
        }
      },
      "description": "about creation drugalergies",
      "example": {
        "name":"1",
        "description":"4"
      }
    },
    "updatedrugalergiesResponse":{
      "type":"object",
      "description":"get the updatedrugalergiesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createpastList":{
      "type": "object",
      "properties": {
        "from": {
          "type": "number",
          "description": "from date"
        },
        "to": {
          "type": "number",
          "description": "to date"
        },
        "apptId": {
          "type": "string",
          "description": "id of tha appoint"
        },
        "consultant": {
          "type": "string",
          "description": "consultant of tha appoint"
        }
      },
      "description": "about creation apptlist",
      "example": {
        "from":"1",
        "to":"4",
        "apptId":"5",
        "consultant":"6"
      }
    },
    "createpastListResponse":{
      "type":"object",
      "description":"get the createpastListResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createInvitation":{
      "type": "object",
      "properties": {
        "link": {
          "type": "string",
          "description": "link to join meeting"
        },
        "email": {
          "type": "string",
          "description": "email"
        }
      },
      "description": "about creation apptlist",
      "example": {
        "email":"paavan@gmail.com",
        "link":"link to meeting"
      }
    },
    "createInvitationResponse":{
      "type":"object",
      "description":"get the createInvitationResponse",
      "example":{
        "response":{
          "data":"email send successfully"
        }
      }
    },
    "getsendsmslambdaResponse":{
      "type":"object",
      "description":"get the getsendsmslambdaResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "updatecancelappointment":{
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "id of user"
        },
        "type": {
          "type": "string",
          "description": "type of appiointment"
        },
        "endTime": {
          "type": "string",
          "description": "endTime of appiointment"
        },
        "startTime": {
          "type": "string",
          "description": "startTime of appiointment"
        },
        "consultantId": {
          "type": "string",
          "description": "id of consultant"
        }
      },
      "description": "about creation apptlist",
      "example": {
        
          "type":"doctor",
          "startTime":"1669106340000",
          "id":"477b22d0-6a55-11ed-a1a9-4d790ca90700",
          "endTime":"1669107240000",
          "consultantId":"96ee36e0-6a2d-11ed-815e-39dc30574417"
        
      }
    },
    "updatecancelappointmentResponse":{
      "type":"object",
      "description":"get the updatecancelappointmentResponse",
      "example":{
        "response":{
          "data":{
            "status": true,
            "data": {
              "_id": "637cac7b0427966f1aba6b79",
              "appointmentId": "477b22d0-6a55-11ed-a1a9-4d790ca90700",
              "consultantId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
              "corporateId": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "startTime": 1669106340000,
              "endTime": 1669107240000,
              "scheduleId": "f7ae1541-6a37-11ed-8638-a122bc0d08ff",
              "slotId": "8ffd9270-6a3e-11ed-a153-0553ba9b2089",
              "reason": "test",
              "description": "",
              "appt_status": "cancelled",
              "userData": {
                "name": "abyssuser",
                "gender": "",
                "phone": "",
                "subdomain": "testapp",
                "email": "abyssuser@yopmail.com",
                "consultId": "U25576"
              },
              "consultantData": {
                "name": "abysscon",
                "email": "abysscon@yopmail.com",
                "consultantType": "Legal_Consultant",
                "currency": "INR",
                "subdomain": "testapp",
                "title": "Mr./Mrs."
              },
              "createdBy": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "uploads": [],
              "appt_day": 2,
              "createdAt": 1669115003147,
              "paymentStatus": "initiated",
              "consultationType": "Legal_Consultant",
              "paymentIntentId": "",
              "updatedAt": "2022-11-23T09:38:02.807Z",
              "__v": 0,
              "cancelledBy": "doctor",
              "refundStatus": "invalid",
              "updatedDate": 1669196282247
            }
          }
        }
      }
    },
    "getdoctorsignsResponse":{
      "type":"object",
      "description":"get the getdoctorsignsResponse",
      "example":{
        "response":{
          "data":"[] || items data"
        }
      }
    },
    "deleteFiledeleteResponse":{
      "type":"object",
      "description":"get the deleteFiledeleteResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteDrugAllergyResponse":{
      "type":"object",
      "description":"get the deleteDrugAllergyResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createenterparticipantlogs":{
      "type": "object",
      "properties": {
        "email": {
          "type": "string",
          "description": " email of user"
        },
        "appointmentId": {
          "type": "string",
          "description": "appointmentId of appointment"
        },
        "enterUTC": {
          "type": "string",
          "description": "utc of user"
        },
        "guest": {
          "type": "string",
          "description": "guest of participant"
        }
      },
      "description": "about creation enterParticipant",
      "example": {
        "email" :"pavan@gmail.com",
        "appointmentId":"477b22d0-6a55-11ed-a1a9-4d790ca90700",
        "enterUTC":12312321,
        "guest":"qwew"
      }
    },
    "createenterparticipantlogsResponse":{
      "type":"object",
      "description":"get the createenterparticipantlogsResponse",
      "example":{
        "response":{
          "data":{
            "status": true,
            "data": {
              "email": "pavan@gmail.com",
              "appointmentId": "477b22d0-6a55-11ed-a1a9-4d790ca90700",
              "enterUTC": 12312321,
              "createdAt": 1669201241834,
              "guest": "qwew"
            }
          }
        }
      }
    },
    "createexitparticipantlogs":{
      "type": "object",
      "properties": {
        "callStatus": {
          "type": "boolean",
          "description": " status of call"
        },
        "appointmentId": {
          "type": "string",
          "description": "appointmentId of appointment"
        }
      },
      "description": "about creation enterParticipant",
      "example": {
        "callStatus":"1",
        "appointmentId":"4"
      }
    },
    "createexitparticipantlogsResponse":{
      "type":"object",
      "description":"get the createexitparticipantlogsResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createupdatesuccesscall":{
      "type": "object",
      "properties": {
        "appointmentId": {
          "type": "string",
          "description": "appointmentId of appointment"
        }
      },
      "description": "about creation enterParticipant",
      "example": {
        "appointmentId":"477b22d0-6a55-11ed-a1a9-4d790ca90700"
      }
    },
    "createupdatesuccesscallResponse":{
      "type":"object",
      "description":"get the createupdatesuccesscallResponse",
      "example":{
        "response":{
          "data":{
            "status": true,
            "data": {
              "_id": "637cac7b0427966f1aba6b79",
              "appointmentId": "477b22d0-6a55-11ed-a1a9-4d790ca90700",
              "consultantId": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "userId": "57bb5100-6a38-11ed-b813-2501004b39ce",
              "corporateId": "0da9ac80-455e-4d2f-9424-77b18638293f",
              "startTime": 1669106340000,
              "endTime": 1669107240000,
              "scheduleId": "f7ae1541-6a37-11ed-8638-a122bc0d08ff",
              "slotId": "8ffd9270-6a3e-11ed-a153-0553ba9b2089",
              "reason": "test",
              "description": "",
              "appt_status": "cancelled",
              "userData": {
                "name": "abyssuser",
                "gender": "",
                "phone": "",
                "subdomain": "testapp",
                "email": "abyssuser@yopmail.com",
                "consultId": "U25576"
              },
              "consultantData": {
                "name": "abysscon",
                "email": "abysscon@yopmail.com",
                "consultantType": "Legal_Consultant",
                "currency": "INR",
                "subdomain": "testapp",
                "title": "Mr./Mrs."
              },
              "createdBy": "96ee36e0-6a2d-11ed-815e-39dc30574417",
              "uploads": [],
              "appt_day": 2,
              "createdAt": 1669115003147,
              "paymentStatus": "initiated",
              "consultationType": "Legal_Consultant",
              "paymentIntentId": "",
              "updatedAt": "2022-11-23T11:10:28.774Z",
              "__v": 0,
              "cancelledBy": "doctor",
              "refundStatus": "invalid",
              "updatedDate": 1669201828237,
              "call_status": true
            }
          }
        }
      }
    },
    "createinviteuser":{
      "type": "object",
      "properties": {
        "link": {
          "type": "string",
          "description": "link of invite"
        },
        "email": {
          "type": "string",
          "description": "email of user"
        },
        "lname": {
          "type": "string",
          "description": "lname of user"
        },
        "fname": {
          "type": "string",
          "description": "fname of user"
        },
        "startTime": {
          "type": "string",
          "description": "startTime of user"
        },
        "endTime": {
          "type": "string",
          "description": "endTime of user"
        }
      },
      "description": "about creation invite",
      "example": {
        "fname":"pavan",
        "lname":"kumar",
        "email":"pavan@gmail.com",
        "startTime":"1669106340000",
        "endTime":"1669107240000",
        "link":"app.inconsullt.vc"
      }
    },
    "createinviteuserResponse":{
      "type":"object",
      "description":"get the createinviteuserResponse",
      "example":{
        "response":{
          "data":"Email sent successfully"
        }
      }
    },
    "getchatlistResponse":{
      "type":"object",
      "description":"get the getchatlistResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createpaymentupdatewebhookResponse":{
      "type":"object",
      "description":"get the createpaymentupdatewebhookResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "updatechedule":{
      "type": "object",
      "properties": {
        "from": {
          "type": "string",
          "description": "from date"
        },
        "to": {
          "type": "string",
          "description": "to  date"
        },
        "days": {
          "type": "number",
          "description": "days"
        }
      },
      "description": "about creation invite",
      "example": {
        "from":"1",
        "to":"2",
        "days":"3"
      }
    },
    "updatescheduleResponse":{
      "type":"object",
      "description":"get the createscheduleResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getScheduleResponse":{
      "type":"object",
      "description":"get the getScheduleResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createschedule":{
      "type": "object",
      "properties": {
        "from": {
          "type": "number",
          "description": "from"
        },
        "to": {
          "type": "number",
          "description": "to"
        },
        "days": {
          "type": "number",
          "description": "days"
        },
        "groupId": {
          "type": "string",
          "description": "groupId of user"
        }
      },
      "description": "about creation invite",
      "example": {
        "from":"1",
        "to":"2",
        "days":"3",
        "groupId":"4"
      }
    },
    "createscheduleResponse":{
      "type":"object",
      "description":"get the createscheduleResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deletescheduleResponse":{
      "type":"object",
      "description":"get the deletescheduleResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteschResponse":{
      "type":"object",
      "description":"get the deleteschResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getconfirmdeleteschResponse":{
      "type":"object",
      "description":"get the getconfirmdeleteschResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "updateslots":{
      "type": "object",
      "properties": {
        "from": {
          "type": "number",
          "description": "from "
        },
        "to": {
          "type": "number",
          "description": "to "
        },
        "duration": {
          "type": "string",
          "description": "duration"
        },
        "label": {
          "type": "string",
          "description": "lebel"
        }
      },
      "description": "about creation invite",
      "example": {
        "from":"1",
        "to":"2",
        "duration":"3",
        "label":"4"
      }
    },
    "updateslotsResponse":{
      "type":"object",
      "description":"get the updateslotsResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getSlotResponse":{
      "type":"object",
      "description":"get the updateslotsResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createslot":{
      "type": "object",
      "properties": {
        "from": {
          "type": "number",
          "description": "from "
        },
        "to": {
          "type": "number",
          "description": "to "
        },
        "duration": {
          "type": "string",
          "description": "duration"
        },
        "scheduleId": {
          "type": "string",
          "description": "scheduleId"
        },
        "label": {
          "type": "string",
          "description": "label"
        }
      },
      "description": "about creation invite",
      "example": {
        "from":"1",
        "to":"2",
        "duration":"3",
        "scheduleId":"5",
        "label":"4"
      }
    },
    "createslotResponse":{
      "type":"object",
      "description":"get the createslotResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteslotResponse":{
      "type":"object",
      "description":"get the deleteslotResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createdisabledates":{
      "type": "object",
      "properties": {
        "dates": {
          "type": "number",
          "description": "dates"
        }
      },
      "description": "about dates",
      "example": {
        "dates":"1"
      }
    },
    "createdisabledatesResponse":{
      "type":"object",
      "description":"create the createdisabledatesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getdisabledatesResponse":{
      "type":"object",
      "description":"create the getdisabledatesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "appointmentstatus":{
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "id of the appointment"
        },
        "status": {
          "type": "string",
          "description": "staus of the appointment"
        },
        "corporateId": {
          "type": "string",
          "description": "corporateId of the corporate"
        },
        "consultantId": {
          "type": "string",
          "description": "consultantId of the consultant"
        }
      },
      "description": "about dates",
      "example": {
        "dates":"1"
      }
    },
    "appointmentstatusResponse":{
      "type":"object",
      "description":"create the appointmentstatus",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "waitingroomupload":{
      "type": "object",
      "properties": {
        "uploadkey": {
          "type": "string",
          "description": "uploadkey of waitingroom"
        },
        "uploadtype": {
          "type": "string",
          "description": "type of the room"
        },
        "uploadname": {
          "type": "string",
          "description": "name of the waitingroom"
        },
        "url": {
          "type": "string",
          "description": "url of the waitingroom"
        },
        "size": {
          "type": "string",
          "description": "size of the waitingroom"
        }
      },
      "description": "about dates",
      "example": {
        "uploadkey":"1",
        "uploadtype":"2",
        "uploadname":"3",
        "url":"4",
        "size":"5"
      }
    },
    "waitingroomuploadResponse":{
      "type":"object",
      "description":"create the waitingroomuploadResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "uploadKeyResponse":{
      "type":"object",
      "description":"create the waitingroomuploadResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getPrescriptionResponse":{
      "type":"object",
      "description":"create the getPrescriptionResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createprescription":{
      "type": "object",
      "properties": {
        "appointmentId": {
          "type": "string",
          "description": "uploadkey of waitingroom"
        },
        "doctorId": {
          "type": "string",
          "description": "doctorId"
        },
        "patientId": {
          "type": "string",
          "description": "patientId"
        },
        "clinicId": {
          "type": "string",
          "description": "clinicId"
        },
        "drugs": {
          "type": "string",
          "description": "drugs"
        },
        "complaint": {
          "type": "string",
          "description": "complaint"
        },
        "diagnosis": {
          "type": "string",
          "description": " diagnosis"
        },
        "investigation": {
          "type": "string",
          "description": "investigation"
        },
        "remarks": {
          "type": "string",
          "description": "remarks"
        },
        "chiefComplaint": {
          "type": "string",
          "description": "chiefComplaint"
        },
        "prescriptionpath": {
          "type": "string",
          "description": "prescriptionpath"
        }
      },
      "description": "about dates",
      "example": {
        "appointmentId":"11",
        "doctorId":"10",
        "patientId":"9",
        "clinicId":"8",
        "drugs":"7",
        "complaint":"6",
        "diagnosis":"5",
        "investigation":"4",
        "remarks":"3",
        "chiefComplaint":"2",
        "prescriptionpath":"1"
      }
    },
    "createprescriptionResponse":{
      "type":"object",
      "description":"create the getPrescriptionResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteprescription":{
      "type": "object",
      "properties": {
        "appointmentId": {
          "type": "string",
          "description": "uploadkey of waitingroom"
        }
      },
      "description": "about dates",
      "example": {
        "appointmentId":"11"
      }
    },
    "deleteprescriptionResponse":{
      "type":"object",
      "description":"create the getPrescriptionResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "updatePrescriptionResponse":{
      "type":"object",
      "description":"create the updatePrescriptionResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteprescriptions":{
      "type": "object",
      "properties": {
        "appointmentId": {
          "type": "string",
          "description": "uploadkey of waitingroom"
        }
      },
      "description": "about prescription",
      "example": {
        "appointmentId":"11"
      }
    },
    "deleteprescriptionsResponse":{
      "type":"object",
      "description":"create the deleteprescriptionsResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createInvite":{
      "type": "object",
      "properties": {
        "email": {
          "type": "string",
          "description": "email of user"
        },
        "name": {
          "type": "string",
          "description": "name of user"
        }
      },
      "description": "about prescription",
      "example": {
        "email":"11",
        "name":"1"
      }
    },
    "createInviteResponse":{
      "type":"object",
      "description":"create the createInviteResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "getInviteeResponse":{
      "type":"object",
      "description":"create the createInviteResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteInvite":{
      "type": "object",
      "properties": {
        "email": {
          "type": "string",
          "description": "email of user"
        }
      },
      "description": "about prescription",
      "example": {
        "email":"11"
      }
    },
    "deleteInviteResponse":{
      "type":"object",
      "description":"create the deleteInviteResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deleteinvitees":{
      "type": "object",
      "properties": {
        "email": {
          "type": "string",
          "description": "email of user"
        }
      },
      "description": "about prescription",
      "example": {
        "email":"11"
      }
    },
    "deleteinviteesResponse":{
      "type":"object",
      "description":"create the deleteInvitesResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "waitingroomResponseResponse":{
      "type":"object",
      "description":"create the waitingroomResponseResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "createdoctorsign":{
      "type": "object",
      "properties": {
        "uploadurl": {
          "type": "string",
          "description": "uploadurl of user"
        },
        "uploadkey": {
          "type": "string",
          "description": "uploadkey of user"
        },
        "uploadtype": {
          "type": "string",
          "description": "uploadtype of user"
        }
      },
      "description": "about prescription",
      "example": {
        "uploadurl":"11",
        "uploadkey":"12",
        "uploadtype":"13"
      }
    },
    "createdoctorsignResponse":{
      "type":"object",
      "description":"create the createdoctorsignResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deletedoctorsign":{
      "type": "object",
      "properties": {
        "uploadurl": {
          "type": "string",
          "description": "uploadurl of user"
        },
        "uploadkey": {
          "type": "string",
          "description": "uploadkey of user"
        },
        "uploadtype": {
          "type": "string",
          "description": "uploadtype of user"
        }
      },
      "description": "about prescription",
      "example": {
        "uploadurl":"11",
        "uploadkey":"12",
        "uploadtype":"13"
      }
    },
    "deletedoctorsignResponse":{
      "type":"object",
      "description":"create the deletedoctorssignResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "deletedoctorssign":{
      "type": "object",
      "properties": {
        "uploadtype": {
          "type": "string",
          "description": "uploadtype of user"
        }
      },
      "description": "about prescription",
      "example": {
        "uploadtype":"13"
      }
    },
    "deletedoctorssignResponse":{
      "type":"object",
      "description":"create the deletedoctorssignResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    },
    "updatedoctorsign":{
      "type": "object",
      "properties": {
        "uploadtype": {
          "type": "string",
          "description": "uploadtype of user"
        }
      },
      "description": "about prescription",
      "example": {
        "uploadtype":"13"
      }
    },
    "updatedoctorsignResponse":{
      "type":"object",
      "description":"create the deletedoctorssignResponse",
      "example":{
        "response":{
          "data":"data"
        }
      }
    }
    }
}
}
;